"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// node_modules/is-hotkey/lib/index.js
var require_lib = __commonJS({
  "node_modules/is-hotkey/lib/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var IS_MAC = typeof window != "undefined" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
    var MODIFIERS = {
      alt: "altKey",
      control: "ctrlKey",
      meta: "metaKey",
      shift: "shiftKey"
    };
    var ALIASES = {
      add: "+",
      break: "pause",
      cmd: "meta",
      command: "meta",
      ctl: "control",
      ctrl: "control",
      del: "delete",
      down: "arrowdown",
      esc: "escape",
      ins: "insert",
      left: "arrowleft",
      mod: IS_MAC ? "meta" : "control",
      opt: "alt",
      option: "alt",
      return: "enter",
      right: "arrowright",
      space: " ",
      spacebar: " ",
      up: "arrowup",
      win: "meta",
      windows: "meta"
    };
    var CODES = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      control: 17,
      alt: 18,
      pause: 19,
      capslock: 20,
      escape: 27,
      " ": 32,
      pageup: 33,
      pagedown: 34,
      end: 35,
      home: 36,
      arrowleft: 37,
      arrowup: 38,
      arrowright: 39,
      arrowdown: 40,
      insert: 45,
      delete: 46,
      meta: 91,
      numlock: 144,
      scrolllock: 145,
      ";": 186,
      "=": 187,
      ",": 188,
      "-": 189,
      ".": 190,
      "/": 191,
      "`": 192,
      "[": 219,
      "\\": 220,
      "]": 221,
      "'": 222
    };
    for (f = 1; f < 20; f++) {
      CODES["f" + f] = 111 + f;
    }
    var f;
    function isHotkey2(hotkey, options2, event) {
      if (options2 && !("byKey" in options2)) {
        event = options2;
        options2 = null;
      }
      if (!Array.isArray(hotkey)) {
        hotkey = [hotkey];
      }
      var array = hotkey.map(function(string) {
        return parseHotkey(string, options2);
      });
      var check = function check2(e) {
        return array.some(function(object) {
          return compareHotkey(object, e);
        });
      };
      var ret = event == null ? check : check(event);
      return ret;
    }
    function isCodeHotkey(hotkey, event) {
      return isHotkey2(hotkey, event);
    }
    function isKeyHotkey(hotkey, event) {
      return isHotkey2(hotkey, { byKey: true }, event);
    }
    function parseHotkey(hotkey, options2) {
      var byKey = options2 && options2.byKey;
      var ret = {};
      hotkey = hotkey.replace("++", "+add");
      var values = hotkey.split("+");
      var length = values.length;
      for (var k in MODIFIERS) {
        ret[MODIFIERS[k]] = false;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = void 0;
      try {
        for (var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;
          var optional = value.endsWith("?") && value.length > 1;
          if (optional) {
            value = value.slice(0, -1);
          }
          var name = toKeyName(value);
          var modifier = MODIFIERS[name];
          if (value.length > 1 && !modifier && !ALIASES[value] && !CODES[name]) {
            throw new TypeError('Unknown modifier: "' + value + '"');
          }
          if (length === 1 || !modifier) {
            if (byKey) {
              ret.key = name;
            } else {
              ret.which = toKeyCode(value);
            }
          }
          if (modifier) {
            ret[modifier] = optional ? null : true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
      return ret;
    }
    function compareHotkey(object, event) {
      for (var key in object) {
        var expected = object[key];
        var actual = void 0;
        if (expected == null) {
          continue;
        }
        if (key === "key" && event.key != null) {
          actual = event.key.toLowerCase();
        } else if (key === "which") {
          actual = expected === 91 && event.which === 93 ? 91 : event.which;
        } else {
          actual = event[key];
        }
        if (actual == null && expected === false) {
          continue;
        }
        if (actual !== expected) {
          return false;
        }
      }
      return true;
    }
    function toKeyCode(name) {
      name = toKeyName(name);
      var code = CODES[name] || name.toUpperCase().charCodeAt(0);
      return code;
    }
    function toKeyName(name) {
      name = name.toLowerCase();
      name = ALIASES[name] || name;
      return name;
    }
    exports.default = isHotkey2;
    exports.isHotkey = isHotkey2;
    exports.isCodeHotkey = isCodeHotkey;
    exports.isKeyHotkey = isKeyHotkey;
    exports.parseHotkey = parseHotkey;
    exports.compareHotkey = compareHotkey;
    exports.toKeyCode = toKeyCode;
    exports.toKeyName = toKeyName;
  }
});

// node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "node_modules/lodash/_freeGlobal.js"(exports, module2) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module2.exports = freeGlobal;
  }
});

// node_modules/lodash/_root.js
var require_root = __commonJS({
  "node_modules/lodash/_root.js"(exports, module2) {
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module2.exports = root;
  }
});

// node_modules/lodash/isFinite.js
var require_isFinite = __commonJS({
  "node_modules/lodash/isFinite.js"(exports, module2) {
    var root = require_root();
    var nativeIsFinite = root.isFinite;
    function isFinite2(value) {
      return typeof value == "number" && nativeIsFinite(value);
    }
    module2.exports = isFinite2;
  }
});

// src/components/EmbedTile/index.ts
var EmbedTile_exports = {};
__export(EmbedTile_exports, {
  EmbedTile: () => EmbedTile,
  EmbedTileAnchor: () => EmbedTileAnchor,
  EmbedTileErrorContent: () => EmbedTileErrorContent,
  EmbedTileIconImage: () => EmbedTileIconImage,
  EmbedTileLinkContent: () => EmbedTileLinkContent,
  EmbedTileMediaContent: () => EmbedTileMediaContent,
  EmbedTileMediaTile: () => EmbedTileMediaTile,
  EmbedTileProfilePanel: () => EmbedTileProfilePanel,
  EmbedTileReactionPanel: () => EmbedTileReactionPanel,
  EmbedTileTextContent: () => EmbedTileTextContent,
  EmbedTileType: () => EmbedTileType5,
  MediaType: () => MediaType,
  ReactionType: () => ReactionType2,
  defaultTwitterUrl: () => defaultTwitterUrl,
  embedTileDetails: () => embedTileDetails,
  genericTileHoverEffectClassName: () => genericTileHoverEffectClassName,
  isBonjoroResponseEmbed: () => isBonjoroResponseEmbed,
  isLinkedinEmbed: () => isLinkedinEmbed,
  isTwitterEmbed: () => isTwitterEmbed,
  mapTwitterProps: () => mapTwitterProps
});
module.exports = __toCommonJS(EmbedTile_exports);

// src/components/EmbedTile/EmbedTile.tsx
var import_react43 = __toESM(require("react"));
var import_classnames30 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileProfilePanel.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var import_react_loading_skeleton = __toESM(require("react-loading-skeleton"));

// src/theme/colors.ts
var palette = {
  black: "#000000",
  white: "#FFFFFF",
  red: ["#F9DEDC", "#F0ADA8", "#E77B73", "#DE4A3F", "#C6413E"],
  orange: [
    "#FFEEE6",
    "#FFDCCC",
    "#FFB99A",
    "#FF9767",
    "#FF7435",
    "#FF5102",
    "#CC4102",
    "#993101",
    "#662001",
    "#331000"
  ],
  yellow: [
    "#F7F4EA",
    "#FFF6CC",
    "#FFEC9A",
    "#FFE367",
    "#FFD935",
    "#FFD002",
    "#CCA602",
    "#997D01",
    "#665301",
    "#332A00"
  ],
  green: [
    "#FAFFEF",
    "#E7F4CC",
    "#CFE999",
    "#B8DD67",
    "#A0D234",
    "#88C701",
    "#6D9F01",
    "#527701",
    "#365000",
    "#1B2800"
  ],
  turquoise: ["#E3F2F2", "#BADEDE", "#9ED0D1", "#4EA4A6", "#22A0AC", "#1C7E87"],
  blue: [
    "#F5F7FF",
    "#CCD6FF",
    "#9AADFF",
    "#6783FF",
    "#355AFF",
    "#0231FF",
    "#0227CC",
    "#011D99",
    "#011466",
    "#000A33"
  ],
  purple: ["#E6E5F0", "#B5B1D3", "#847CB6", "#675EA5", "#514983"],
  pink: ["#FFEFF4", "#FFD0DF", "#F2A6BE", "#EC799D", "#D0577D"],
  brown: ["#9B803D", "#8E652A", "#5B4028", "#473A31", "#2D241D", "#1C1616"],
  neutral: [
    "#F2F2F2",
    "#E2E3E7",
    "#C4C7CF",
    "#A7AAB8",
    "#898EA0",
    "#6C7288",
    "#565B6D",
    "#414452",
    "#2B2E36",
    "#16171B"
  ],
  magenta: [
    "#FFF8FF",
    "#F0CEEA",
    "#E19DD6",
    "#D16DC1",
    "#C23CAD",
    "#B30B98",
    "#A10A89",
    "#7D086A",
    "#5A064C",
    "#36032E"
  ]
};
var colors = {
  white: palette.white,
  black: palette.black,
  current: "currentColor",
  transparent: "transparent",
  neutral: {
    DEFAULT: palette.neutral[9],
    50: palette.neutral[0],
    100: palette.neutral[1],
    200: palette.neutral[2],
    300: palette.neutral[3],
    400: palette.neutral[4],
    500: palette.neutral[5],
    600: palette.neutral[6],
    700: palette.neutral[7],
    800: palette.neutral[8],
    900: palette.neutral[9]
  },
  red: {
    DEFAULT: palette.red[3],
    100: palette.red[0],
    300: palette.red[1],
    500: palette.red[2],
    700: palette.red[3],
    900: palette.red[4]
  },
  orange: {
    DEFAULT: palette.orange[5],
    50: palette.orange[0],
    100: palette.orange[1],
    200: palette.orange[2],
    300: palette.orange[3],
    400: palette.orange[4],
    500: palette.orange[5],
    600: palette.orange[6],
    700: palette.orange[7],
    800: palette.orange[8],
    900: palette.orange[9]
  },
  yellow: {
    DEFAULT: palette.yellow[5],
    50: palette.yellow[0],
    100: palette.yellow[1],
    200: palette.yellow[2],
    300: palette.yellow[3],
    400: palette.yellow[4],
    500: palette.yellow[5],
    600: palette.yellow[6],
    700: palette.yellow[7],
    800: palette.yellow[8],
    900: palette.yellow[9]
  },
  green: {
    DEFAULT: palette.green[5],
    50: palette.green[0],
    100: palette.green[1],
    200: palette.green[2],
    300: palette.green[3],
    400: palette.green[4],
    500: palette.green[5],
    600: palette.green[6],
    700: palette.green[7],
    800: palette.green[8],
    900: palette.green[9]
  },
  turquoise: {
    DEFAULT: palette.turquoise[4],
    100: palette.turquoise[0],
    300: palette.turquoise[1],
    500: palette.turquoise[2],
    600: palette.turquoise[3],
    700: palette.turquoise[4],
    900: palette.turquoise[5]
  },
  blue: {
    DEFAULT: palette.blue[5],
    50: palette.blue[0],
    100: palette.blue[1],
    200: palette.blue[2],
    300: palette.blue[3],
    400: palette.blue[4],
    500: palette.blue[5],
    600: palette.blue[6],
    700: palette.blue[7],
    800: palette.blue[8],
    900: palette.blue[9]
  },
  purple: {
    DEFAULT: palette.purple[3],
    100: palette.purple[0],
    300: palette.purple[1],
    500: palette.purple[2],
    700: palette.purple[3],
    900: palette.purple[4]
  },
  pink: {
    DEFAULT: palette.pink[3],
    100: palette.pink[0],
    300: palette.pink[1],
    500: palette.pink[2],
    700: palette.pink[3],
    900: palette.pink[4]
  },
  brown: {
    DEFAULT: palette.brown[3],
    50: palette.brown[0],
    100: palette.brown[1],
    300: palette.brown[2],
    500: palette.brown[3],
    700: palette.brown[4],
    900: palette.brown[5]
  },
  magenta: {
    DEFAULT: palette.magenta[5],
    50: palette.magenta[0],
    100: palette.magenta[1],
    200: palette.magenta[2],
    300: palette.magenta[3],
    400: palette.magenta[4],
    500: palette.magenta[5],
    600: palette.magenta[6],
    700: palette.magenta[7],
    800: palette.magenta[8],
    900: palette.magenta[9]
  }
};

// src/theme/typography.ts
var typography = {
  standard: "Lato"
};

// src/theme/index.ts
var theme = {
  colors,
  extend: {
    screens: {
      xxs: "320px",
      xs: "425px",
      // Widget mobile breakpoint
      wm: "500px"
    },
    fontSize: {
      xxs: [
        ".5rem",
        {
          lineHeight: "0.75rem"
        }
      ]
    },
    fontFamily: {
      sans: ["Circular Std", typography.standard, "sans-serif"],
      circular: ["Circular Std", "Arial", "san-serif"]
    },
    boxShadow: {
      top: "0 -4px 4px 0 rgba(166, 166, 166, 0.13)",
      around: "0 1px 10px 0 rgba(0, 0, 0, 0.16)",
      "3xl": "5px 3px 6px #00000029"
    },
    dropShadow: {
      text: "0px 3px 6px #00000029"
    },
    zIndex: {
      "99": 99
    },
    spacing: {
      "30": "7.5rem",
      "37": "9.375rem"
    },
    animation: {
      "fade-in-100": "fade-in .1s linear forwards",
      "fade-in-150": "fade-in .15s linear forwards",
      "fade-in": "fade-in .25s linear forwards",
      "fade-out-100": "fade-out .1s linear forwards",
      "fade-out-150": "fade-out .15s linear forwards",
      "fade-out": "fade-out .25s linear forwards",
      "fade-in-down-150": "fade-in-down .15s linear 1",
      "fade-in-down": "fade-in-down .25s linear 1",
      "fade-out-down-150": "fade-out-down .15s linear 1",
      "fade-out-down": "fade-out-down .25s linear 1",
      "fade-in-up-150": "fade-in-up .15s linear 1",
      "fade-in-up": "fade-in-up .25s linear 1",
      "fade-out-up-150": "fade-out-up .15s linear 1",
      "fade-out-up": "fade-out-up .25s linear 1",
      "fade-in-left-150": "fade-in-left .15s linear 1",
      "fade-in-left": "fade-in-left .25s linear 1",
      "fade-out-left-150": "fade-out-left .15s linear 1",
      "fade-out-left": "fade-out-left .25s linear 1",
      "fade-in-right-150": "fade-in-right .15s linear 1",
      "fade-in-right": "fade-in-right .25s linear 1",
      "fade-out-right-150": "fade-out-right .15s linear 1",
      "fade-out-right": "fade-out-right .25s linear 1",
      "rotate-360": "rotate-360 2s linear infinite"
    },
    keyframes: {
      "rotate-360": {
        "0%": { transform: "rotate(0deg)" },
        "100%": { transform: "rotate(360deg)" }
      },
      "fade-in": {
        "0%": { opacity: "0" },
        "100%": { opacity: "1" }
      },
      "fade-out": {
        "0%": { opacity: "1" },
        "100%": { opacity: "0" }
      },
      "fade-in-down": {
        "0%": { opacity: "0", transform: "translateY(-20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-down": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(20px)" }
      },
      "fade-in-up": {
        "0%": { opacity: "0", transform: "translateY(20px)" },
        "100%": { opacity: "1", transform: "translateY(0)" }
      },
      "fade-out-up": {
        "0%": { opacity: "1", transform: "translateY(0)" },
        "100%": { opacity: "0", transform: "translateY(-20px)" }
      },
      "fade-in-left": {
        "0%": { opacity: "0", transform: "translateX(20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-left": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(-20px)" }
      },
      "fade-in-right": {
        "0%": { opacity: "0", transform: "translateX(-20px)" },
        "100%": { opacity: "1", transform: "translateX(0)" }
      },
      "fade-out-right": {
        "0%": { opacity: "1", transform: "translateX(0)" },
        "100%": { opacity: "0", transform: "translateX(20px)" }
      }
    }
  }
};

// src/components/EmbedTile/EmbedTileProfilePanel.tsx
function Loading() {
  return /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-w-full v2-flex v2-space-x-2.5" }, /* @__PURE__ */ import_react.default.createElement(
    import_react_loading_skeleton.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      circle: true,
      containerClassName: "v2-h-10 v2-w-10 v2-flex"
    }
  ), /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-w-3/5 v2-flex v2-flex-col v2-space-y-1" }, /* @__PURE__ */ import_react.default.createElement(
    import_react_loading_skeleton.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      containerClassName: "v2-h-5 v2-w-3/5 v2-flex"
    }
  ), /* @__PURE__ */ import_react.default.createElement(
    import_react_loading_skeleton.default,
    {
      baseColor: colors.neutral[200],
      highlightColor: colors.neutral[100],
      height: "100%",
      containerClassName: "v2-h-3.5 v2-w-3/5 v2-flex"
    }
  )));
}
function EmbedTileProfilePanel({
  imageUrl,
  name,
  tag,
  url,
  className,
  imageClassName,
  nameClassName,
  tagClassName,
  hideProfileImage = false,
  hideProfileName = false,
  hideProfileTag = false,
  loading = false,
  imageComponent: DefaultImageComponent
}) {
  if (loading)
    return /* @__PURE__ */ import_react.default.createElement(Loading, null);
  const imageProps = {
    src: imageUrl,
    width: 0,
    height: 0,
    alt: "Profile Picture",
    className: (0, import_classnames.default)(imageClassName, [
      "v2-rounded-full v2-h-10 v2-w-10 v2-object-cover v2-transition-all v2-ease-in-out",
      "group-hover:v2-outline-blue-300 group-hover:v2-outline",
      "group-hover:-v2-outline-offset-2 group-hover:v2-outline-2"
    ])
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return imageUrl;
      }
    })
  ) : /* @__PURE__ */ import_react.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react.default.createElement(
    "a",
    {
      className: (0, import_classnames.default)(className, [
        "v2-flex v2-flex-row v2-gap-x-2.5 v2-items-center",
        "v2-group v2-truncate"
      ]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    !hideProfileImage && imageUrl && imageComponent,
    /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-flex v2-flex-col v2-items-start v2-justify-between v2-gap-1" }, !hideProfileName && name && /* @__PURE__ */ import_react.default.createElement(
      "span",
      {
        className: (0, import_classnames.default)(nameClassName, [
          "v2-text-neutral-900 v2-text-base group-hover:v2-underline"
        ])
      },
      name
    ), !hideProfileTag && tag && /* @__PURE__ */ import_react.default.createElement(
      "span",
      {
        className: (0, import_classnames.default)(tagClassName, [
          "v2-text-neutral-500 v2-text-xs group-hover:v2-underline"
        ])
      },
      tag
    ))
  );
}

// src/components/EmbedTile/EmbedTileReactionPanel.tsx
var import_react18 = __toESM(require("react"));
var import_classnames15 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileIconImage.tsx
var import_react16 = __toESM(require("react"));

// src/components/Nav/MainNavigation/LogoHeader.tsx
var import_react2 = __toESM(require("react"));
var import_classnames2 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/MainNavigation.tsx
var import_react3 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/MaskedImage.tsx
var import_react4 = __toESM(require("react"));
var import_styled = __toESM(require("@emotion/styled"));
var import_classnames4 = __toESM(require("classnames"));
var Image = import_styled.default.i`
  ${({ imageUrl, bgColor, hideWhiteBackground = false }) => `
    ${!hideWhiteBackground ? "background-color: white;" : ""}
    ${bgColor ? `background-color: ${bgColor} !important;` : ""}
    mask: url("${imageUrl}");
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `}
`;

// src/components/Nav/MainNavigation/NavContainer.tsx
var import_react5 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavGroup.tsx
var import_react6 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavItem.tsx
var import_react8 = __toESM(require("react"));
var import_classnames8 = __toESM(require("classnames"));
var import_styled2 = __toESM(require("@emotion/styled"));

// src/components/Nav/MainNavigation/NavItemLabel.tsx
var import_react7 = __toESM(require("react"));
var import_classnames7 = __toESM(require("classnames"));

// src/components/Nav/MainNavigation/NavItem.tsx
var hoverImageStyle = (hoverImageUrl) => `
  i {
    background: url("${hoverImageUrl != null ? hoverImageUrl : ""}") no-repeat 0 0;
    background-position: center;
    mask: none;
  }
`;
var ItemContainer = import_styled2.default.li`
  ${({ hoverImageUrl, active }) => `
    ${hoverImageUrl ? `:hover { ${hoverImageStyle(hoverImageUrl)}}` : ""}
    ${active ? hoverImageStyle(hoverImageUrl) : ""}
  `}
`;

// src/components/Nav/NavProfileDropdown/NavProfileDropdown.tsx
var import_react15 = __toESM(require("react"));
var import_classnames13 = __toESM(require("classnames"));

// src/components/Nav/NavProfileIcon/NavProfileIcon.tsx
var import_react9 = __toESM(require("react"));
var import_classnames9 = __toESM(require("classnames"));
var import_react_fontawesome = require("@fortawesome/react-fontawesome");

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItems.tsx
var import_react11 = __toESM(require("react"));

// src/components/Nav/NavProfileDropdown/NavProfileDropdownItem.tsx
var import_react10 = __toESM(require("react"));
var import_classnames10 = __toESM(require("classnames"));

// src/components/Dropdown/Dropdown.tsx
var import_react14 = __toESM(require("react"));
var import_classnames12 = __toESM(require("classnames"));

// src/components/Dropdown/DropdownContainer.tsx
var import_react12 = __toESM(require("react"));
var import_classnames11 = __toESM(require("classnames"));

// src/hook/use-detect-outside-click-hook.ts
var import_react13 = require("react");

// src/components/EmbedTile/EmbedTileIconImage.tsx
var import_classnames14 = __toESM(require("classnames"));
function EmbedTileIconImage({
  type,
  reactionType,
  loading = false,
  theme: theme2,
  className,
  imageComponent: DefaultImageComponent,
  height = 0,
  width = 0
}) {
  var _a, _b, _c, _d, _e;
  const defaultClassName = "v2-shrink-0 v2-transition-all";
  const details = reactionType ? (_c = (_b = (_a = embedTileDetails) == null ? void 0 : _a[type]) == null ? void 0 : _b.reactions) == null ? void 0 : _c[reactionType] : (_e = (_d = embedTileDetails) == null ? void 0 : _d[type]) == null ? void 0 : _e.icon;
  if (!details)
    return /* @__PURE__ */ import_react16.default.createElement(import_react16.default.Fragment, null);
  const { url, iconType, iconClassName } = details;
  const imageProps = {
    src: url,
    alt: "Icon Image",
    width,
    height,
    className: (0, import_classnames14.default)(className, iconClassName, defaultClassName, {
      "v2-grayscale": loading
    })
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react16.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return url;
      }
    })
  ) : /* @__PURE__ */ import_react16.default.createElement("img", __spreadValues({}, imageProps));
  if (iconType === "masked_image") {
    return /* @__PURE__ */ import_react16.default.createElement(
      Image,
      {
        imageUrl: url,
        className: (0, import_classnames14.default)(className, iconClassName, defaultClassName, {
          "!v2-bg-neutral-200": loading
        }),
        bgColor: theme2 == null ? void 0 : theme2.primaryColor,
        hideWhiteBackground: true
      }
    );
  }
  return imageComponent;
}

// src/utils.ts
var import_react17 = __toESM(require("react"));
function openFullScreen(videoElement) {
  if (videoElement.requestFullscreen) {
    videoElement.requestFullscreen();
  } else if (videoElement.webkitEnterFullscreen) {
    videoElement.webkitEnterFullscreen();
  } else if (videoElement.msRequestFullscreen) {
    videoElement.msRequestFullscreen();
  } else if (videoElement.mozRequestFullScreen) {
    videoElement.mozRequestFullScreen();
  } else {
    throw new Error("fullscreenElement is not supported by this browser");
  }
}
function toCompactNumber(number = 0, precision = 1) {
  return Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: precision
  }).format(number);
}

// src/components/EmbedTile/EmbedTileReactionPanel.tsx
var import_react_loading_skeleton2 = __toESM(require("react-loading-skeleton"));
function EmbedTileReactionPanel({
  type,
  reactions,
  url,
  className,
  reactionClassName,
  countClassName,
  loading = false
}) {
  const totalReactions = reactions == null ? void 0 : reactions.reduce((n, { count }) => n + count, 0);
  if (!totalReactions && !loading)
    return /* @__PURE__ */ import_react18.default.createElement(import_react18.default.Fragment, null);
  return /* @__PURE__ */ import_react18.default.createElement(
    "a",
    {
      className: (0, import_classnames15.default)(className, [
        "v2-flex v2-flex-row v2-gap-x-2.5 v2-items-center",
        "v2-cursor-pointer v2-group"
      ]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    loading && /* @__PURE__ */ import_react18.default.createElement("span", { className: "v2-flex v2-flex-row v2-gap-x-[3px]" }, /* @__PURE__ */ import_react18.default.createElement(
      EmbedTileIconImage,
      {
        type,
        reactionType: "like" /* Like */,
        className: (0, import_classnames15.default)(reactionClassName),
        width: 15,
        height: 15,
        loading: true
      }
    )),
    reactions && /* @__PURE__ */ import_react18.default.createElement(
      "span",
      { className: "v2-flex v2-flex-row v2-gap-x-[3px]" },
      /** Show only up to 3 reactions */
      reactions.slice(0, 3).map(({ type: reactionType }, index) => {
        return /* @__PURE__ */ import_react18.default.createElement(
          EmbedTileIconImage,
          {
            key: index,
            type,
            reactionType,
            className: (0, import_classnames15.default)(reactionClassName, "v2-h-[15px] v2-w-[15px]")
          }
        );
      })
    ),
    /* @__PURE__ */ import_react18.default.createElement(
      "span",
      {
        className: (0, import_classnames15.default)(countClassName, [
          "v2-flex v2-text-neutral-500 v2-text-xs v2-font-bold",
          "v2-transition-all group-hover:v2-text-neutral-900"
        ])
      },
      loading ? /* @__PURE__ */ import_react18.default.createElement(
        import_react_loading_skeleton2.default,
        {
          baseColor: colors.neutral[200],
          highlightColor: colors.neutral[100],
          height: "100%",
          containerClassName: "v2-h-4 v2-w-6 v2-flex"
        }
      ) : toCompactNumber(reactions == null ? void 0 : reactions.reduce((n, { count }) => n + count, 0))
    )
  );
}

// src/components/EmbedTile/EmbedTileTextContent.tsx
var import_react31 = __toESM(require("react"));

// node_modules/linkify-react/dist/linkify-react.es.js
var React18 = __toESM(require("react"));
var import_linkifyjs = require("linkifyjs");
function stringToElements(str, opts, meta) {
  const tokens = (0, import_linkifyjs.tokenize)(str);
  const elements = [];
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.t === "nl" && opts.get("nl2br")) {
      const key = `__linkify-el-${meta.elementId++}`;
      elements.push(React18.createElement("br", {
        key
      }));
    } else if (!token.isLink || !opts.check(token)) {
      elements.push(token.toString());
    } else {
      let rendered = opts.render(token);
      if (!("key" in rendered.props)) {
        const key = `__linkify-el-${meta.elementId++}`;
        const props = import_linkifyjs.options.assign({
          key
        }, rendered.props);
        rendered = React18.cloneElement(rendered, props);
      }
      elements.push(rendered);
    }
  }
  return elements;
}
function linkifyReactElement(element, opts, meta) {
  if (React18.Children.count(element.props.children) === 0) {
    return element;
  }
  const children = [];
  React18.Children.forEach(element.props.children, (child) => {
    if (typeof child === "string") {
      children.push.apply(children, stringToElements(child, opts, meta));
    } else if (React18.isValidElement(child)) {
      if (typeof child.type === "string" && opts.ignoreTags.indexOf(child.type.toUpperCase()) >= 0) {
        children.push(child);
      } else {
        children.push(linkifyReactElement(child, opts, meta));
      }
    } else {
      children.push(child);
    }
  });
  const key = `__linkify-el-${meta.elementId++}`;
  const newProps = import_linkifyjs.options.assign({
    key
  }, element.props);
  return React18.cloneElement(element, newProps, children);
}
var Linkify = (props) => {
  let linkId = 0;
  const defaultLinkRender = (_ref) => {
    let {
      tagName,
      attributes,
      content
    } = _ref;
    attributes.key = `__linkify-lnk-${linkId++}`;
    if (attributes.class) {
      attributes.className = attributes.class;
      delete attributes.class;
    }
    return React18.createElement(tagName, attributes, content);
  };
  const newProps = {
    key: "__linkify-wrapper"
  };
  for (const prop in props) {
    if (prop !== "options" && prop !== "as" && prop !== "tagName" && prop !== "children") {
      newProps[prop] = props[prop];
    }
  }
  const opts = new import_linkifyjs.Options(props.options, defaultLinkRender);
  const as = props.as || props.tagName || React18.Fragment || "span";
  const children = props.children;
  const element = React18.createElement(as, newProps, children);
  return linkifyReactElement(element, opts, {
    elementId: 0
  });
};

// node_modules/linkify-plugin-hashtag/dist/linkify-plugin-hashtag.es.js
var import_linkifyjs2 = require("linkifyjs");
var HashtagToken = (0, import_linkifyjs2.createTokenClass)("hashtag", {
  isLink: true
});
function hashtag(_ref) {
  let {
    scanner,
    parser
  } = _ref;
  const {
    POUND,
    UNDERSCORE
  } = scanner.tokens;
  const {
    alpha,
    numeric,
    alphanumeric,
    emoji
  } = scanner.tokens.groups;
  const Hash = parser.start.tt(POUND);
  const HashPrefix = Hash.tt(UNDERSCORE);
  const Hashtag = new import_linkifyjs2.State(HashtagToken);
  Hash.ta(numeric, HashPrefix);
  Hash.ta(alpha, Hashtag);
  Hash.ta(emoji, Hashtag);
  HashPrefix.ta(alpha, Hashtag);
  HashPrefix.ta(emoji, Hashtag);
  HashPrefix.ta(numeric, HashPrefix);
  HashPrefix.tt(UNDERSCORE, HashPrefix);
  Hashtag.ta(alphanumeric, Hashtag);
  Hashtag.ta(emoji, Hashtag);
  Hashtag.tt(UNDERSCORE, Hashtag);
}
(0, import_linkifyjs2.registerPlugin)("hashtag", hashtag);

// src/components/EmbedTile/EmbedTileTextContent.tsx
var import_styled4 = __toESM(require("@emotion/styled"));

// src/components/RichTextViewer/RichTextViewer.tsx
var import_react30 = __toESM(require("react"));

// src/components/RichTextEditor/Buttons/BaseButton.tsx
var import_react19 = __toESM(require("react"));
var import_classnames16 = __toESM(require("classnames"));
var BaseButton = (_a) => {
  var _b = _a, {
    className,
    icon,
    active,
    onClick
  } = _b, props = __objRest(_b, [
    "className",
    "icon",
    "active",
    "onClick"
  ]);
  return /* @__PURE__ */ import_react19.default.createElement(
    "button",
    __spreadProps(__spreadValues({}, props), {
      className: (0, import_classnames16.default)(
        className,
        [
          "v2-border-0 v2-cursor-pointer v2-px-1.5 v2-flex v2-items-center",
          "hover:v2-bg-turquoise-100 v2-rounded v2-select-none v2-h-6"
        ],
        {
          "v2-bg-neutral-100": !active,
          "v2-bg-neutral-200": active,
          "v2-opacity-20": props.disabled
        }
      ),
      onMouseDown: (event) => {
        event.preventDefault();
        onClick == null ? void 0 : onClick();
      }
    }),
    icon
  );
};

// src/components/RichTextEditor/Buttons/BlockButton.tsx
var import_react29 = __toESM(require("react"));
var import_slate_react5 = require("slate-react");

// src/components/RichTextEditor/utils.ts
var import_slate3 = require("slate");

// src/components/RichTextEditor/types.ts
var TextAlignType = /* @__PURE__ */ ((TextAlignType2) => {
  TextAlignType2["Center"] = "center";
  TextAlignType2["Left"] = "left";
  TextAlignType2["Right"] = "right";
  TextAlignType2["Justify"] = "justify";
  return TextAlignType2;
})(TextAlignType || {});
var hotkeys = {
  "mod+b": "bold" /* Bold */,
  "mod+i": "italic" /* Italic */,
  "mod+u": "underline" /* Underline */
};
var listStyles = [
  "numbered-list" /* NumberedList */,
  "bulleted-list" /* BulletedList */
];

// src/components/RichTextEditor/Editor/index.tsx
var import_react28 = __toESM(require("react"));
var import_is_hotkey = __toESM(require_lib());
var import_slate_react4 = require("slate-react");
var import_classnames20 = __toESM(require("classnames"));

// src/components/RichTextEditor/Renderer/Element.tsx
var import_react20 = __toESM(require("react"));
var import_styled3 = __toESM(require("@emotion/styled"));
var OrderedList = import_styled3.default.ol`
  li {
    padding-bottom: 0.75rem;
  }
`;
var Element = ({ attributes, children, element }) => {
  const style = { textAlign: element.align, color: "unset" };
  switch (element.type) {
    case "heading-one" /* HeadingOne */:
      return /* @__PURE__ */ import_react20.default.createElement(
        "h1",
        __spreadValues({
          className: "v2-text-[2rem] v2-font-normal v2-leading-10 v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "heading-two" /* HeadingTwo */:
      return /* @__PURE__ */ import_react20.default.createElement(
        "h2",
        __spreadValues({
          className: "v2-text-2xl v2-font-normal v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "bulleted-list" /* BulletedList */:
      return /* @__PURE__ */ import_react20.default.createElement(
        "ul",
        __spreadValues({
          className: "v2-list-inside v2-list-disc v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    case "list-item" /* ListItem */:
      return /* @__PURE__ */ import_react20.default.createElement("li", __spreadValues({ style }, attributes), children);
    case "numbered-list" /* NumberedList */:
      return /* @__PURE__ */ import_react20.default.createElement(
        OrderedList,
        __spreadValues({
          className: "v2-list-inside v2-list-decimal v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
    default:
      return /* @__PURE__ */ import_react20.default.createElement(
        "p",
        __spreadValues({
          className: "v2-break-words empty:v2-h-6 v2-p-0 v2-m-0",
          style
        }, attributes),
        children
      );
  }
};

// src/components/RichTextEditor/Renderer/Leaf.tsx
var import_react21 = __toESM(require("react"));
var Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = /* @__PURE__ */ import_react21.default.createElement("strong", { className: "v2-font-bold" }, children);
  }
  if (leaf.italic) {
    children = /* @__PURE__ */ import_react21.default.createElement("em", { className: "v2-italic" }, children);
  }
  if (leaf.underline) {
    children = /* @__PURE__ */ import_react21.default.createElement("u", { className: "v2-underline" }, children);
  }
  if (leaf.decoration === "link" /* Link */) {
    children = /* @__PURE__ */ import_react21.default.createElement(
      "a",
      {
        className: "v2-text-blue-400 hover:!v2-text-blue-300",
        href: leaf.text,
        target: "_blank",
        rel: "noreferrer"
      },
      children
    );
  }
  return /* @__PURE__ */ import_react21.default.createElement("span", __spreadValues({}, attributes), children);
};

// src/components/RichTextEditor/Toolbar/index.tsx
var import_react25 = __toESM(require("react"));

// src/components/RichTextEditor/Buttons/MarkButton.tsx
var import_react22 = __toESM(require("react"));
var import_slate_react = require("slate-react");
var MarkButton = ({
  className,
  type,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react.useSlate)();
  const onClickHandler = () => toggleMark(editor, type);
  return /* @__PURE__ */ import_react22.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      active: isMarkActive(editor, type),
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextEditor/Toolbar/index.tsx
var import_classnames18 = __toESM(require("classnames"));

// src/components/RichTextEditor/Toolbar/GroupContainer.tsx
var import_react23 = __toESM(require("react"));
var import_classnames17 = __toESM(require("classnames"));
function GroupContainer({ className, children }) {
  return /* @__PURE__ */ import_react23.default.createElement(
    "div",
    {
      className: (0, import_classnames17.default)(
        className,
        "v2-flex v2-px-1.5 sm:v2-gap-x-2.5 sm:v2-px-2.5"
      )
    },
    children
  );
}

// src/components/RichTextEditor/Buttons/FormatButton.tsx
var import_react24 = __toESM(require("react"));
var import_slate_react2 = require("slate-react");
var import_slate = require("slate");
var clearBlockFormatting = (editor) => {
  import_slate.Transforms.unwrapNodes(editor, {
    match: (n) => !import_slate.Editor.isEditor(n) && import_slate.Element.isElement(n) && listStyles.includes(n.type),
    split: true
  });
  import_slate.Transforms.setNodes(editor, {
    type: "paragraph" /* Paragraph */
  });
};
var clearMarkFormatting = (editor) => {
  import_slate.Editor.removeMark(editor, "bold" /* Bold */);
  import_slate.Editor.removeMark(editor, "italic" /* Italic */);
  import_slate.Editor.removeMark(editor, "underline" /* Underline */);
};
var clearFormatting = (editor) => {
  clearBlockFormatting(editor);
  clearMarkFormatting(editor);
};
var FormatButton = ({
  className,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react2.useSlate)();
  const onClickHandler = () => clearFormatting(editor);
  return /* @__PURE__ */ import_react24.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextEditor/Toolbar/index.tsx
var boldMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bold-mark.svg";
var italicMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/italic-mark.svg";
var underlineMarkIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/underline-mark.svg";
var bulletedBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/bulleted-block.svg";
var numberedBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/numbered-block.svg";
var headingOneBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/heading-one-block.svg";
var headingTwoBlockIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/heading-two-block.svg";
var clearFormatIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/clear-format.svg";
function Toolbar({
  className,
  groupClassName,
  config,
  containerRef,
  disabled = false,
  toolbarPosition = "bottom"
}) {
  const {
    hideBold,
    hideUnderline,
    hideItalic,
    hideBulletedList,
    hideNumberedList,
    hideHeadingOne,
    hideHeadingTwo,
    hideClearFormat
  } = (0, import_react25.useMemo)(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
      hideBold: (_a = config == null ? void 0 : config.hideBold) != null ? _a : false,
      hideUnderline: (_b = config == null ? void 0 : config.hideUnderline) != null ? _b : false,
      hideItalic: (_c = config == null ? void 0 : config.hideItalic) != null ? _c : false,
      hideBulletedList: (_d = config == null ? void 0 : config.hideBulletedList) != null ? _d : false,
      hideNumberedList: (_e = config == null ? void 0 : config.hideNumberedList) != null ? _e : false,
      hideHeadingOne: (_f = config == null ? void 0 : config.hideHeadingOne) != null ? _f : false,
      hideHeadingTwo: (_g = config == null ? void 0 : config.hideHeadingTwo) != null ? _g : false,
      hideClearFormat: (_h = config == null ? void 0 : config.hideClearFormat) != null ? _h : false
    };
  }, [config]);
  const headingButtons = (!hideHeadingOne || !hideHeadingTwo) && /* @__PURE__ */ import_react25.default.createElement(GroupContainer, { className: groupClassName }, !hideHeadingOne && /* @__PURE__ */ import_react25.default.createElement(
    BlockButton,
    {
      disabled,
      style: "heading-one" /* HeadingOne */,
      icon: /* @__PURE__ */ import_react25.default.createElement("img", { className: "v2-h-4 v2-w-3", src: headingOneBlockIcon })
    }
  ), !hideHeadingTwo && /* @__PURE__ */ import_react25.default.createElement(
    BlockButton,
    {
      disabled,
      style: "heading-two" /* HeadingTwo */,
      icon: /* @__PURE__ */ import_react25.default.createElement("img", { className: "v2-h-4 v2-w-3", src: headingTwoBlockIcon })
    }
  ));
  const formatButtons = (!hideBold || !hideItalic || !hideUnderline) && /* @__PURE__ */ import_react25.default.createElement(GroupContainer, { className: groupClassName }, !hideBold && /* @__PURE__ */ import_react25.default.createElement(
    MarkButton,
    {
      disabled,
      type: "bold" /* Bold */,
      className: "!v2-px-[7px]",
      icon: /* @__PURE__ */ import_react25.default.createElement("img", { className: "v2-h-3 v2-w-2.5", src: boldMarkIcon })
    }
  ), !hideItalic && /* @__PURE__ */ import_react25.default.createElement(
    MarkButton,
    {
      disabled,
      type: "italic" /* Italic */,
      className: "!v2-px-2",
      icon: /* @__PURE__ */ import_react25.default.createElement("img", { className: "v2-h-3 v2-w-2", src: italicMarkIcon })
    }
  ), !hideUnderline && /* @__PURE__ */ import_react25.default.createElement(
    MarkButton,
    {
      disabled,
      type: "underline" /* Underline */,
      icon: /* @__PURE__ */ import_react25.default.createElement("img", { className: "v2-h-3 v2-w-3", src: underlineMarkIcon })
    }
  ));
  const listButtons = (!hideBulletedList || !hideNumberedList) && /* @__PURE__ */ import_react25.default.createElement(GroupContainer, { className: groupClassName }, !hideBulletedList && /* @__PURE__ */ import_react25.default.createElement(
    BlockButton,
    {
      disabled,
      style: "bulleted-list" /* BulletedList */,
      icon: /* @__PURE__ */ import_react25.default.createElement("img", { className: "v2-h-4 v2-w-3", src: bulletedBlockIcon })
    }
  ), !hideNumberedList && /* @__PURE__ */ import_react25.default.createElement(
    BlockButton,
    {
      disabled,
      style: "numbered-list" /* NumberedList */,
      icon: /* @__PURE__ */ import_react25.default.createElement("img", { className: "v2-h-4 v2-w-3", src: numberedBlockIcon })
    }
  ));
  const clearFormatButton = !hideClearFormat && /* @__PURE__ */ import_react25.default.createElement(GroupContainer, { className: groupClassName }, /* @__PURE__ */ import_react25.default.createElement(
    FormatButton,
    {
      disabled,
      className: "!v2-px-1.5 !v2-py-1",
      icon: /* @__PURE__ */ import_react25.default.createElement("img", { className: "v2-h-3 v2-w-3", src: clearFormatIcon })
    }
  ));
  const buttonComponents = (0, import_react25.useMemo)(() => {
    const components = [
      headingButtons,
      formatButtons,
      listButtons,
      clearFormatButton
    ];
    return components.filter((component) => component != false);
  }, [config]);
  return /* @__PURE__ */ import_react25.default.createElement(
    "div",
    {
      ref: containerRef,
      className: (0, import_classnames18.default)(className, ["v2-flex v2-py-1 v2-bg-neutral-100 v2-h-8"], {
        "v2-rounded-t-sm": toolbarPosition == "top",
        "v2-rounded-b-sm": toolbarPosition == "bottom"
      })
    },
    buttonComponents.map((child, index) => /* @__PURE__ */ import_react25.default.createElement(import_react25.default.Fragment, { key: index }, !!index && /* @__PURE__ */ import_react25.default.createElement("span", { className: "v2-h-6 v2-w-[1px] v2-bg-neutral-300" }), child))
  );
}

// src/components/RichTextEditor/Container/index.tsx
var import_react26 = __toESM(require("react"));
var import_classnames19 = __toESM(require("classnames"));
function Container(_a) {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ import_react26.default.createElement("div", __spreadValues({ className: (0, import_classnames19.default)(className, "v2-font-circular") }, props), children);
}

// src/components/RichTextEditor/use-editor-hook.ts
var import_react27 = require("react");
var import_slate2 = require("slate");
var import_slate_history = require("slate-history");
var import_slate_react3 = require("slate-react");
var useEditor = () => {
  return {
    editor: (0, import_react27.useMemo)(() => (0, import_slate_history.withHistory)((0, import_slate_react3.withReact)((0, import_slate2.createEditor)())), [])
  };
};

// src/utils/url.ts
var findUrlsInText = (text) => {
  const urlRegex = (
    // eslint-disable-next-line no-useless-escape
    /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim
  );
  const matches = text.match(urlRegex);
  return matches ? matches.map((m) => [m.trim(), text.indexOf(m.trim())]) : [];
};

// src/components/RichTextEditor/Editor/index.tsx
var defaultEmptyRichTextValue = [
  {
    type: "paragraph" /* Paragraph */,
    children: [
      {
        text: ""
      }
    ]
  }
];
var RichTextEditor = (_a) => {
  var _b = _a, {
    value,
    onChange,
    placeholder = "Enter some rich text\u2026",
    className,
    editorClassName,
    toolbarClassName,
    toolbarGroupClassName,
    toolbarConfig,
    toolbarPosition = "bottom",
    editor: initialEditor,
    hideToolbar = false,
    onKeyDown,
    onScrollToView,
    style
  } = _b, props = __objRest(_b, [
    "value",
    "onChange",
    "placeholder",
    "className",
    "editorClassName",
    "toolbarClassName",
    "toolbarGroupClassName",
    "toolbarConfig",
    "toolbarPosition",
    "editor",
    "hideToolbar",
    "onKeyDown",
    "onScrollToView",
    "style"
  ]);
  const { readOnly } = props;
  const toolbarRef = (0, import_react28.useRef)(null);
  const [content, setContent] = (0, import_react28.useState)(
    value != null ? value : defaultEmptyRichTextValue
  );
  const editor = initialEditor != null ? initialEditor : useEditor().editor;
  const slateDecorator = ([node, path]) => {
    const nodeText = node.text;
    if (!nodeText)
      return [];
    const urls = findUrlsInText(nodeText);
    return urls.map(([url, index]) => {
      return {
        anchor: {
          path,
          offset: index
        },
        focus: {
          path,
          offset: index + url.length
        },
        decoration: "link" /* Link */
      };
    });
  };
  const onKeyDownHandler = (event) => {
    onKeyDown == null ? void 0 : onKeyDown(event);
    for (const hotkey in hotkeys) {
      if ((0, import_is_hotkey.default)(hotkey, event)) {
        event.preventDefault();
        const mark = hotkeys[hotkey];
        toggleMark(editor, mark);
      }
    }
  };
  (0, import_react28.useEffect)(() => {
    if (value !== null && value !== void 0) {
      editor.children = value;
      setContent(value);
    }
  }, [value]);
  const onChangeHandler = (value2) => {
    setContent(value2);
    onChange == null ? void 0 : onChange(value2);
  };
  return /* @__PURE__ */ import_react28.default.createElement(import_slate_react4.Slate, { editor, initialValue: content, onChange: onChangeHandler }, /* @__PURE__ */ import_react28.default.createElement(
    Container,
    {
      style,
      className: (0, import_classnames20.default)(
        className,
        [
          "v2-rounded v2-border v2-border-neutral-200 v2-border-solid",
          "v2-flex v2-h-full v2-w-full v2-text-neutral-900"
        ],
        {
          "v2-flex-col": toolbarPosition === "bottom",
          "v2-flex-col-reverse": toolbarPosition === "top"
        }
      )
    },
    /* @__PURE__ */ import_react28.default.createElement(
      import_slate_react4.Editable,
      __spreadProps(__spreadValues({}, props), {
        key: "rich-text-editor",
        renderElement: Element,
        renderLeaf: Leaf,
        placeholder,
        renderPlaceholder: ({ attributes, children }) => /* @__PURE__ */ import_react28.default.createElement(
          "span",
          __spreadProps(__spreadValues({}, attributes), {
            style: __spreadProps(__spreadValues({}, attributes.style), {
              display: "unset"
            })
          }),
          children
        ),
        className: (0, import_classnames20.default)(editorClassName, [
          "v2-scrollbar-thin v2-scrollbar-track-neutral-200 v2-p-2",
          "v2-scrollbar-thumb-neutral-400 v2-scrollbar-thumb-rounded-full",
          "v2-overflow-x-hidden v2-h-full v2-w-auto v2-outline-none"
        ]),
        onKeyDown: onKeyDownHandler,
        scrollSelectionIntoView: onScrollToView,
        decorate: slateDecorator
      })
    ),
    !hideToolbar && /* @__PURE__ */ import_react28.default.createElement(
      Toolbar,
      {
        key: "rich-text-toolbar",
        containerRef: toolbarRef,
        className: toolbarClassName,
        groupClassName: toolbarGroupClassName,
        config: toolbarConfig,
        toolbarPosition,
        disabled: readOnly
      }
    )
  ));
};

// src/components/RichTextEditor/utils.ts
var checkIfTextAlignType = (style) => {
  return Object.values(TextAlignType).includes(
    style
  );
};
var isBlockActive = (editor, style, blockType = "type") => {
  const { selection } = editor;
  if (!selection)
    return false;
  const [match] = Array.from(
    import_slate3.Editor.nodes(editor, {
      at: import_slate3.Editor.unhangRange(editor, selection),
      match: (n) => !import_slate3.Editor.isEditor(n) && import_slate3.Element.isElement(n) && n[blockType] === style
    })
  );
  return !!match;
};
var isMarkActive = (editor, style) => {
  const marks = import_slate3.Editor.marks(editor);
  return marks ? marks[style] === true : false;
};
var toggleBlock = (editor, style) => {
  const isTextAlignType = checkIfTextAlignType(style);
  const isList = listStyles.includes(style);
  const isActive = isBlockActive(
    editor,
    style,
    isTextAlignType ? "align" : "type"
  );
  import_slate3.Transforms.unwrapNodes(editor, {
    match: (n) => !import_slate3.Editor.isEditor(n) && import_slate3.Element.isElement(n) && listStyles.includes(n.type) && !isTextAlignType,
    split: true
  });
  let newProperties;
  if (isTextAlignType) {
    newProperties = {
      align: isActive ? void 0 : style
    };
  } else {
    newProperties = {
      type: isActive ? "paragraph" /* Paragraph */ : isList ? "list-item" /* ListItem */ : style
    };
  }
  import_slate3.Transforms.setNodes(editor, newProperties);
  if (!isActive && isList) {
    const block = { type: style, children: [] };
    import_slate3.Transforms.wrapNodes(editor, block);
  }
};
var toggleMark = (editor, style) => {
  const isActive = isMarkActive(editor, style);
  if (isActive) {
    import_slate3.Editor.removeMark(editor, style);
  } else {
    import_slate3.Editor.addMark(editor, style, true);
  }
};

// src/components/RichTextEditor/Buttons/BlockButton.tsx
var BlockButton = ({
  className,
  style,
  icon,
  disabled = false
}) => {
  const editor = (0, import_slate_react5.useSlate)();
  const onClickHandler = () => toggleBlock(editor, style);
  return /* @__PURE__ */ import_react29.default.createElement(
    BaseButton,
    {
      disabled,
      className,
      active: isBlockActive(
        editor,
        style,
        checkIfTextAlignType(style) ? "align" : "type"
      ),
      onClick: onClickHandler,
      icon
    }
  );
};

// src/components/RichTextViewer/RichTextViewer.tsx
function RichTextViewer({
  value,
  className = "",
  style
}) {
  return /* @__PURE__ */ import_react30.default.createElement(
    RichTextEditor,
    {
      className: `!v2-border-0 ${className}`,
      editorClassName: "!v2-p-0",
      placeholder: "",
      value,
      style,
      readOnly: true,
      hideToolbar: true
    }
  );
}

// src/components/EmbedTile/EmbedTileTextContent.tsx
var Container2 = import_styled4.default.span`
  a {
    color: ${colors.blue[400]};

    &:hover {
      text-decoration: underline;
    }
  }
`;
function EmbedTileTextContent({
  type,
  text,
  style
}) {
  const options2 = (0, import_react31.useMemo)(() => {
    const defaultOptions = {
      nl2br: true,
      target: "_blank",
      rel: "noopener noreferrer"
    };
    if (isTwitterEmbed(type)) {
      return __spreadProps(__spreadValues({}, defaultOptions), {
        formatHref: {
          hashtag: (href) => "https://twitter.com/hashtag/" + href.substr(1)
        }
      });
    }
    if (isLinkedinEmbed(type)) {
      return __spreadProps(__spreadValues({}, defaultOptions), {
        formatHref: {
          hashtag: (href) => "https://www.linkedin.com/feed/hashtag/?keywords=" + href.substr(1)
        }
      });
    }
  }, [type]);
  const content = typeof text === "string" ? /* @__PURE__ */ import_react31.default.createElement(Linkify, { options: options2 }, text) : /* @__PURE__ */ import_react31.default.createElement(RichTextViewer, { value: text, style });
  return /* @__PURE__ */ import_react31.default.createElement(Container2, { className: "v2-whitespace-pre-wrap v2-px-5" }, content);
}

// src/components/EmbedTile/EmbedTileMediaContent.tsx
var import_react40 = __toESM(require("react"));
var import_classnames27 = __toESM(require("classnames"));

// src/components/EmbedTile/EmbedTileMediaTile.tsx
var import_react39 = __toESM(require("react"));
var import_classnames26 = __toESM(require("classnames"));
var import_styled6 = __toESM(require("@emotion/styled"));

// src/components/VideoPlayer/VideoPlayerComponent.tsx
var import_react38 = __toESM(require("react"));
var import_classnames25 = __toESM(require("classnames"));

// src/components/VideoPlayer/VideoControls.tsx
var import_react37 = __toESM(require("react"));

// src/components/VideoPlayer/VideoPlayerContainer.tsx
var import_react33 = __toESM(require("react"));

// src/components/VideoPlayer/VideoPlayerOverlay.tsx
var import_react32 = __toESM(require("react"));
var import_classnames21 = __toESM(require("classnames"));

// src/components/VideoPlayer/hooks/useVideoProgress.ts
var import_react34 = require("react");
function useVideoProgress({
  videoRef,
  onProgress,
  intervalDelay = 250,
  forceUseInterval = false
}) {
  const [intervalId, setIntervalId] = (0, import_react34.useState)();
  const [playing, setPlaying] = (0, import_react34.useState)(false);
  function handlePlayEvent() {
    setPlaying(true);
  }
  function handlePauseEvent() {
    setPlaying(false);
  }
  (0, import_react34.useEffect)(() => {
    if (videoRef == null ? void 0 : videoRef.current) {
      videoRef.current.addEventListener("play", handlePlayEvent);
      videoRef.current.addEventListener("pause", handlePauseEvent);
    }
    return () => {
      if (!(videoRef == null ? void 0 : videoRef.current))
        return;
      videoRef.current.removeEventListener("play", handlePlayEvent);
      videoRef.current.removeEventListener("pause", handlePauseEvent);
    };
  }, [videoRef == null ? void 0 : videoRef.current]);
  const supportsTimeUpdate = (0, import_react34.useMemo)(() => {
    var _a;
    return !forceUseInterval && ((_a = (videoRef == null ? void 0 : videoRef.current) && "ontimeupdate" in videoRef.current) != null ? _a : false);
  }, [videoRef == null ? void 0 : videoRef.current]);
  function handleTimeUpdate() {
    var _a;
    ((_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.currentTime) != null && (onProgress == null ? void 0 : onProgress(videoRef.current.currentTime));
  }
  (0, import_react34.useEffect)(() => {
    if (supportsTimeUpdate && (videoRef == null ? void 0 : videoRef.current) && onProgress) {
      videoRef.current.addEventListener("timeupdate", handleTimeUpdate);
    }
    return () => {
      if (!(videoRef == null ? void 0 : videoRef.current))
        return;
      videoRef.current.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [supportsTimeUpdate, onProgress]);
  (0, import_react34.useEffect)(() => {
    if (onProgress && playing && (videoRef == null ? void 0 : videoRef.current) && !videoRef.current.paused && !supportsTimeUpdate) {
      setIntervalId(
        setInterval(() => {
          var _a;
          ((_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.currentTime) != null && (onProgress == null ? void 0 : onProgress(videoRef.current.currentTime));
        }, intervalDelay)
      );
    } else if (intervalId) {
      clearInterval(intervalId);
    }
    return () => intervalId && clearInterval(intervalId);
  }, [playing, supportsTimeUpdate]);
}

// src/utils/localStorage.ts
var import_localforage = __toESM(require("localforage"));
var keyToStr = (key) => key.join(".");
function remember(key, value) {
  return import_localforage.default.setItem(keyToStr(key), JSON.stringify(value));
}
function recall(key) {
  return __async(this, null, function* () {
    const json = yield import_localforage.default.getItem(keyToStr(key));
    if (json) {
      return JSON.parse(json);
    }
    return null;
  });
}

// src/components/VideoPlayer/settings.ts
var storageKeys = {
  all: ["bonjoro", "video-player-settings"]
};
function rememberVideoPlayerSettings(settings) {
  return __async(this, null, function* () {
    const currentSettings = yield getVideoPlayerSettings();
    return remember(storageKeys.all, __spreadValues(__spreadValues({}, currentSettings), settings));
  });
}
function getVideoPlayerSettings() {
  return recall(storageKeys.all);
}

// src/components/VideoPlayer/VideoControls.tsx
var import_react_fontawesome2 = require("@fortawesome/react-fontawesome");
var import_classnames24 = __toESM(require("classnames"));
var import_styled5 = __toESM(require("@emotion/styled"));

// node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faCirclePlay = {
  prefix: "fas",
  iconName: "circle-play",
  icon: [512, 512, [61469, "play-circle"], "f144", "M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"]
};
var faCirclePause = {
  prefix: "fas",
  iconName: "circle-pause",
  icon: [512, 512, [62092, "pause-circle"], "f28b", "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
};
var faXmark = {
  prefix: "fas",
  iconName: "xmark",
  icon: [320, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"]
};
var faTimes = faXmark;

// src/components/VideoPlayer/VideoControls.tsx
var import_isFinite = __toESM(require_isFinite());

// src/utils/elapsed.ts
var import_luxon = require("luxon");
function elapsed(input, options2) {
  const duration = (import_luxon.Duration.isDuration(input) ? input : import_luxon.Duration.fromObject({ seconds: input })).shiftTo("hours", "minutes", "seconds");
  const shouldPadMinutes = !(options2 == null ? void 0 : options2.noPadMinutes);
  const format = ` ${duration.hours ? "hh:" : ""}${shouldPadMinutes ? "mm:ss" : "m:ss"}`;
  return duration.toFormat(format);
}

// src/components/Transcript/Transcript.tsx
var import_react35 = __toESM(require("react"));
var import_classnames22 = __toESM(require("classnames"));
var SENTENCE_ENDING_THRESHOLD_MS = 0.15;
var MAX_WORDS_PER_SENTENCE = 15;
function Transcript({
  videoRef,
  sentences,
  mode = "sentence" /* Sentence */,
  maxWordsPerSentence = MAX_WORDS_PER_SENTENCE,
  containerClassName,
  className,
  onClick
}) {
  const [currentTranscription, setCurrentTranscription] = (0, import_react35.useState)();
  const [sentenceEnding, setSentenceEnding] = (0, import_react35.useState)(false);
  const parsedSentences = (0, import_react35.useMemo)(() => {
    if (!sentences || sentences.length === 0)
      return [];
    return sentences == null ? void 0 : sentences.reduce((sentences2, sentence) => {
      var _a, _b, _c;
      const currentSentence = {
        text: sentence.text,
        start: sentence.start / 1e3,
        end: sentence.end / 1e3,
        words: (_a = sentence == null ? void 0 : sentence.words) == null ? void 0 : _a.reduce((words, word) => {
          return [
            ...words,
            {
              text: word.text,
              start: word.start / 1e3,
              end: word.end / 1e3
            }
          ];
        }, [])
      };
      if ((currentSentence == null ? void 0 : currentSentence.words) && ((_b = currentSentence == null ? void 0 : currentSentence.words) == null ? void 0 : _b.length) > maxWordsPerSentence) {
        const chunkedWords = currentSentence == null ? void 0 : currentSentence.words.reduce(
          (words, word, index) => {
            const chunkIndex = Math.floor(index / maxWordsPerSentence);
            if (!words[chunkIndex]) {
              words[chunkIndex] = [];
            }
            words[chunkIndex].push(word);
            return words;
          },
          []
        );
        return [
          ...sentences2,
          ...(_c = chunkedWords == null ? void 0 : chunkedWords.reduce((sentences3, words) => {
            var _a2, _b2;
            return [
              ...sentences3,
              {
                text: words.map((word) => word.text).join(" "),
                start: (_a2 = words[0]) == null ? void 0 : _a2.start,
                end: (_b2 = words[words.length - 1]) == null ? void 0 : _b2.end,
                words
              }
            ];
          }, [])) != null ? _c : []
        ];
      }
      return [...sentences2, currentSentence];
    }, []);
  }, [sentences, maxWordsPerSentence]);
  const hasActiveTranscriptions = (0, import_react35.useMemo)(
    () => currentTranscription !== "" && currentTranscription !== void 0,
    [currentTranscription]
  );
  (0, import_react35.useEffect)(() => {
    if (!(videoRef == null ? void 0 : videoRef.current))
      return;
    const video = videoRef.current;
    const handleTimeUpdate = () => {
      var _a;
      const currentTime = video.currentTime;
      const currentTranscription2 = parsedSentences.find(
        (transcription) => currentTime >= transcription.start && currentTime <= transcription.end
      );
      if (currentTranscription2 && currentTime <= (currentTranscription2 == null ? void 0 : currentTranscription2.end) && (currentTranscription2 == null ? void 0 : currentTranscription2.end) - currentTime <= SENTENCE_ENDING_THRESHOLD_MS) {
        setSentenceEnding(true);
      } else {
        setSentenceEnding(false);
      }
      switch (mode) {
        case "sentence" /* Sentence */: {
          setCurrentTranscription(
            currentTranscription2 ? currentTranscription2.text : ""
          );
          break;
        }
        case "word_per_word" /* WordPerWord */: {
          const compiledWords = (_a = currentTranscription2 == null ? void 0 : currentTranscription2.words) == null ? void 0 : _a.filter(
            (word) => currentTime >= currentTranscription2.start && currentTime >= word.end || currentTime >= word.start && currentTime <= word.end
          ).reduce((words, word) => {
            return [...words, word.text];
          }, []);
          setCurrentTranscription(
            compiledWords && (compiledWords == null ? void 0 : compiledWords.length) > 0 ? compiledWords.join(" ") : ""
          );
          break;
        }
      }
    };
    video.addEventListener("timeupdate", handleTimeUpdate);
    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [videoRef == null ? void 0 : videoRef.current, parsedSentences, mode]);
  return /* @__PURE__ */ import_react35.default.createElement(
    "div",
    {
      className: (0, import_classnames22.default)(
        containerClassName,
        "v2-rounded v2-cursor-pointer v2-select-none v2-w-auto"
      ),
      onClick
    },
    /* @__PURE__ */ import_react35.default.createElement(
      "span",
      {
        className: (0, import_classnames22.default)(className, {
          "v2-bg-black/50 v2-text-white v2-text-base v2-p-0.5 v2-select-none v2-animate-fade-in-100 v2-whitespace-normal v2-font-circular": hasActiveTranscriptions,
          "v2-animate-fade-out-100": sentenceEnding
        })
      },
      currentTranscription
    )
  );
}

// src/components/Transcript/CCButton.tsx
var import_react36 = __toESM(require("react"));
var import_classnames23 = __toESM(require("classnames"));
function CCButton({
  show = false,
  onShowClick,
  outerContainerClassName,
  innerContainerClassName,
  iconClassName
}) {
  return /* @__PURE__ */ import_react36.default.createElement(
    "div",
    {
      className: (0, import_classnames23.default)(
        "v2-pr-2.5 v2-pt-2.5 v2-cursor-pointer",
        outerContainerClassName
      )
    },
    /* @__PURE__ */ import_react36.default.createElement(
      "div",
      {
        className: (0, import_classnames23.default)(
          innerContainerClassName,
          [
            "v2-flex v2-items-center v2-p-0.5",
            "v2-rounded-md v2-opacity-25 v2-select-none v2-bg-black"
          ],
          {
            "hover:v2-opacity-50 v2-transition-all ": !show,
            "!v2-opacity-25 v2-bg-black": show
          }
        ),
        onClick: (e) => {
          e.stopPropagation();
          onShowClick == null ? void 0 : onShowClick(!show);
        }
      },
      /* @__PURE__ */ import_react36.default.createElement(
        "div",
        {
          className: (0, import_classnames23.default)(
            iconClassName,
            [
              "v2-text-center v2-items-center v2-justify-center v2-flex v2-text-xs",
              "v2-p-[2.5px] v2-py-0 v2-rounded-md v2-min-w-[25px] v2-min-h-[20px] ",
              "v2-border v2-border-[1.5px] v2-border-white v2-border-solid v2-font-bold",
              "v2-font-circular"
            ],
            {
              "v2-bg-black v2-text-white": !show,
              "v2-bg-white v2-text-neutral": show
            }
          )
        },
        "CC"
      )
    )
  );
}

// src/components/VideoPlayer/VideoControls.tsx
var volumeIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-white.svg";
var volumeMuteIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/volume-mute-white.svg";
var fullScreenIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/full-screen-white.svg";
var exitFullScreenIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/exit-full-screen-white.svg";
var newTabIcon = "https://cdn.bonjoro.com/assets/bonjoro-ui-components/new-tab-white.svg";
var actionIconClass = "v2-overflow-visible v2-z-10 v2-cursor-pointer v2-select-none";
var NewTabIcon = import_styled5.default.img`
  ${({ ctaHoverColor }) => `
    &:hover {
      background-color: ${ctaHoverColor != null ? ctaHoverColor : "transparent"};
    }
  `}
`;
var VideoProgress = import_styled5.default.progress`
  &::-webkit-progress-bar {
    background-color: ${colors.neutral[200]};
  }

  &::-webkit-progress-value {
    background: ${colors.yellow[500]};
  }

  &::-moz-progress-bar {
    background: ${colors.yellow[500]};
  }
`;
var VideoProgressSliderThumb = import_styled5.default.input`
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
  }

  &::-webkit-slider-thumb {
    width: 10px;
    height: 10px;
    background: ${colors.yellow[500]};
    cursor: ew-resize;
    z-index: 50;
  }

  &:hover::-moz-range-thumb {
    width: 10px;
    height: 10px;
    background: ${colors.yellow[500]};
    cursor: ew-resize;
  }
`;
var CtaContainer = import_styled5.default.div`
  ${({ ctaHoverColor }) => `
    &:hover {
      background-color: ${ctaHoverColor != null ? ctaHoverColor : "transparent"};
    }
  `}
`;
function VideoControls({
  fullScreen,
  playing,
  muted,
  showControls = true,
  leftHeaderComponent,
  footerComponent,
  initialTranscriptionState = "closed",
  transcription,
  transcriptMode,
  transcriptionTogglerPosition,
  transcriptionMaxWordsPerSentence,
  transcriptionClassName,
  transcriptionContainerClassName,
  ctaHoverColor,
  hideClose,
  hideNewTab,
  hidePlayPause,
  hideMuteUnmute,
  hideFullScreen,
  hideTranscription,
  onPlayPauseClick,
  onMuteUnmuteClick,
  onFullScreenClick,
  onNewTabClick,
  onCloseClick,
  videoRef,
  hideTimer,
  showProgressBar,
  fadeControlsOnPlay,
  closedCaptionClassName,
  playPauseStyle,
  playPauseClassName,
  playPausePlacement
}) {
  var _a;
  const [currentTime, setCurrentTime] = (0, import_react37.useState)(0);
  const [showTranscription, setShowTranscription] = (0, import_react37.useState)(
    initialTranscriptionState === "open"
  );
  (0, import_react37.useEffect)(() => {
    void getVideoPlayerSettings().then((settings) => {
      var _a2;
      if (!settings)
        return;
      setShowTranscription((_a2 = settings.transcriptionEnabled) != null ? _a2 : false);
    });
  }, []);
  const [formattedCurrentTime, formattedDuration, duration] = (0, import_react37.useMemo)(() => {
    if (!(videoRef == null ? void 0 : videoRef.current)) {
      return [null, null];
    }
    const duration2 = videoRef.current.duration;
    const formattedCurrentTime2 = elapsed(currentTime, { noPadMinutes: true });
    if (!(0, import_isFinite.default)(duration2)) {
      return [null, null];
    }
    const formattedDuration2 = elapsed(duration2, { noPadMinutes: true });
    return [formattedCurrentTime2, formattedDuration2, duration2];
  }, [videoRef == null ? void 0 : videoRef.current, (_a = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a.duration, currentTime]);
  useVideoProgress({
    videoRef,
    onProgress: setCurrentTime,
    intervalDelay: 100,
    forceUseInterval: true
  });
  const onVideoSeek = (0, import_react37.useCallback)(
    (ev) => {
      var _a2;
      ev.preventDefault();
      if (typeof ((_a2 = videoRef == null ? void 0 : videoRef.current) == null ? void 0 : _a2.currentTime) === "undefined")
        return;
      videoRef.current.currentTime = Number(ev.target.value);
    },
    [videoRef == null ? void 0 : videoRef.current]
  );
  const onTranscriptionClick = (show) => {
    void rememberVideoPlayerSettings({
      transcriptionEnabled: show
    });
    setShowTranscription(show);
  };
  const transciptionTogglerProps = {
    show: showTranscription,
    onShowClick: onTranscriptionClick,
    outerContainerClassName: closedCaptionClassName
  };
  const hasValidTranscription = transcription != void 0 && transcription.length > 0;
  const fadeControls = !(fadeControlsOnPlay && !playing || !fadeControlsOnPlay);
  const isPlayPausePlacementCenter = playPausePlacement === "center" /* Center */;
  const isPlayPausePlacementLowerLeft = playPausePlacement === "lower-left" /* LowerLeft */;
  const scaleOnHoverClassName = "v2-transition-all v2-duration-200 hover:v2-scale-105";
  return /* @__PURE__ */ import_react37.default.createElement(import_react37.default.Fragment, null, showControls && /* @__PURE__ */ import_react37.default.createElement(
    "div",
    {
      className: "v2-absolute v2-flex v2-flex-col v2-w-full v2-top-0 v2-z-50",
      onClick: onPlayPauseClick
    },
    /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-flex v2-flex-row v2-justify-between" }, /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-inline-flex" }, leftHeaderComponent, !hideTranscription && hasValidTranscription && transcriptionTogglerPosition === "left" && /* @__PURE__ */ import_react37.default.createElement(
      CCButton,
      __spreadProps(__spreadValues({}, transciptionTogglerProps), {
        outerContainerClassName: "v2-pl-2.5"
      })
    )), /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-inline-flex" }, !hideTranscription && hasValidTranscription && transcriptionTogglerPosition === "right" && /* @__PURE__ */ import_react37.default.createElement(CCButton, __spreadValues({}, transciptionTogglerProps)), !hideNewTab && /* @__PURE__ */ import_react37.default.createElement(
      NewTabIcon,
      {
        ctaHoverColor,
        className: (0, import_classnames24.default)(
          actionIconClass,
          "v2-w-7 v2-h-7 v2-p-1",
          scaleOnHoverClassName
        ),
        src: newTabIcon,
        onClick: (e) => {
          e.stopPropagation();
          onNewTabClick == null ? void 0 : onNewTabClick();
        },
        title: "Open in a new window"
      }
    ), !hideClose && /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-px-1 v2-bg-black v2-bg-opacity-50 v2-h-7 v2-flex v2-items-center" }, /* @__PURE__ */ import_react37.default.createElement(
      import_react_fontawesome2.FontAwesomeIcon,
      {
        className: (0, import_classnames24.default)(
          scaleOnHoverClassName,
          "v2-w-5 v2-h-6 v2-text-white v2-cursor-pointer"
        ),
        icon: faTimes,
        onClick: (e) => {
          e.stopPropagation();
          onCloseClick == null ? void 0 : onCloseClick();
        },
        title: "Close"
      }
    ))))
  ), !hidePlayPause && isPlayPausePlacementCenter && /* @__PURE__ */ import_react37.default.createElement(
    "div",
    {
      className: (0, import_classnames24.default)(
        [
          "v2-absolute v2-top-1/2 v2-left-1/2 v2-flex v2-transition-all v2-duration-200",
          "-v2-translate-x-1/2 -v2-translate-y-1/2 v2-z-[20]",
          ""
        ],
        {
          "v2-animate-fade-in": !playing,
          "v2-animate-fade-out": playing
        }
      )
    },
    /* @__PURE__ */ import_react37.default.createElement(
      import_react_fontawesome2.FontAwesomeIcon,
      {
        onClick: onPlayPauseClick,
        className: (0, import_classnames24.default)(playPauseClassName, scaleOnHoverClassName, [
          "v2-h-[90px] !v2-w-[50px] v2-text-white v2-cursor-pointer"
        ]),
        icon: playing ? faCirclePause : faCirclePlay,
        title: "Play/Pause",
        style: playPauseStyle
      }
    )
  ), /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-absolute v2-flex v2-flex-col v2-w-full v2-bottom-0 v2-z-50" }, !hideTranscription && hasValidTranscription && (videoRef == null ? void 0 : videoRef.current) && !(fadeControlsOnPlay && !playing) && /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-flex v2-items-center v2-justify-center" }, /* @__PURE__ */ import_react37.default.createElement(
    Transcript,
    {
      onClick: onPlayPauseClick,
      sentences: transcription,
      videoRef,
      mode: transcriptMode,
      maxWordsPerSentence: transcriptionMaxWordsPerSentence,
      className: transcriptionClassName,
      containerClassName: (0, import_classnames24.default)(
        transcriptionContainerClassName,
        "v2-text-center v2-w-fit",
        {
          "v2-opacity-0": !showTranscription
        }
      )
    }
  )), showControls && /* @__PURE__ */ import_react37.default.createElement(
    "div",
    {
      className: "v2-flex v2-flex-row v2-justify-between v2-pointer-events-auto v2-z-50 v2-px-3.5 v2-pb-3.5 v2-h-[42px]",
      onClick: onPlayPauseClick
    },
    /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-flex v2-space-x-3.5 v2-items-center" }, !hidePlayPause && isPlayPausePlacementLowerLeft && !fadeControls && /* @__PURE__ */ import_react37.default.createElement(
      import_react_fontawesome2.FontAwesomeIcon,
      {
        onClick: onPlayPauseClick,
        className: (0, import_classnames24.default)(playPauseClassName, [
          "v2-h-[38px] !v2-w-[30px] v2-text-4xl v2-text-white",
          "v2-cursor-pointer v2-animate-fade-in"
        ]),
        icon: playing ? faCirclePause : faCirclePlay,
        title: "Play/Pause",
        style: playPauseStyle
      }
    ), !hideTimer && formattedCurrentTime && formattedDuration && /* @__PURE__ */ import_react37.default.createElement(
      "div",
      {
        className: (0, import_classnames24.default)(
          "v2-group/video-player-timer",
          scaleOnHoverClassName,
          "v2-flex v2-gap-x-1 v2-text-white v2-text-base v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react37.default.createElement("span", { className: "v2-w-[35px] v2-font-circular" }, formattedCurrentTime),
      /* @__PURE__ */ import_react37.default.createElement(
        "span",
        {
          className: (0, import_classnames24.default)(
            "v2-opacity-50 group-hover/video-player-timer:v2-opacity-100",
            "v2-transition-all v2-duration-200 v2-font-circular"
          )
        },
        "/"
      ),
      /* @__PURE__ */ import_react37.default.createElement(
        "span",
        {
          className: (0, import_classnames24.default)(
            "v2-w-[35px] v2-opacity-50 group-hover/video-player-timer:v2-opacity-100",
            "v2-transition-all v2-duration-200 v2-font-circular"
          )
        },
        formattedDuration
      )
    )),
    /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-inline-flex v2-gap-x-3 v2-items-center" }, !hideMuteUnmute && /* @__PURE__ */ import_react37.default.createElement(
      CtaContainer,
      {
        ctaHoverColor,
        className: (0, import_classnames24.default)(
          scaleOnHoverClassName,
          "v2-p-1 v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react37.default.createElement(
        "img",
        {
          className: (0, import_classnames24.default)(actionIconClass, "v2-w-5 v2-h-5"),
          src: muted ? volumeMuteIcon : volumeIcon,
          title: "Mute/Unmute",
          onClick: (e) => {
            e.stopPropagation();
            onMuteUnmuteClick == null ? void 0 : onMuteUnmuteClick();
          }
        }
      )
    ), !hideFullScreen && /* @__PURE__ */ import_react37.default.createElement(
      CtaContainer,
      {
        ctaHoverColor,
        className: (0, import_classnames24.default)(
          scaleOnHoverClassName,
          "v2-p-1 v2-animate-fade-in"
        )
      },
      /* @__PURE__ */ import_react37.default.createElement(
        "img",
        {
          className: (0, import_classnames24.default)(actionIconClass, "v2-w-5 v2-h-5"),
          src: fullScreen ? exitFullScreenIcon : fullScreenIcon,
          onClick: (e) => {
            e.stopPropagation();
            onFullScreenClick == null ? void 0 : onFullScreenClick();
          },
          title: "Full screen"
        }
      )
    ))
  ), showProgressBar && /* @__PURE__ */ import_react37.default.createElement("div", { className: "v2-flex" }, /* @__PURE__ */ import_react37.default.createElement(
    VideoProgress,
    {
      max: duration == null ? void 0 : duration.toFixed(),
      value: currentTime.toFixed(),
      className: "v2-appearance-none v2-w-full v2-h-[10px] v2-absolute v2-bottom-0 v2-transition-all v2-duration-200"
    }
  ), /* @__PURE__ */ import_react37.default.createElement(
    VideoProgressSliderThumb,
    {
      type: "range",
      className: "v2-appearance-none v2-w-full v2-h-[10px] v2-bg-transparent v2-z-10  v2-cursor-ew-resize v2-transition-all v2-duration-200",
      min: 0,
      max: duration == null ? void 0 : duration.toFixed(),
      value: currentTime.toFixed(),
      onChange: onVideoSeek
    }
  )), footerComponent));
}

// src/components/VideoPlayer/VideoPlayerComponent.tsx
function VideoPlayerComponent({
  videoUrl,
  videoTitle,
  videoThumbnail,
  videoThumbnailClassName,
  containerClassName,
  videoClassName,
  playPauseStyle,
  playPauseClassName,
  videoStyle,
  showDefaultFullScreen = false,
  showDefaultControls = false,
  autoPlay = false,
  loop = false,
  fullScreen = false,
  children,
  footerComponent,
  leftHeaderComponent,
  initialTranscriptionState,
  transcription,
  transcriptMode = "sentence" /* Sentence */,
  transcriptionTogglerPosition = "right",
  transcriptionMaxWordsPerSentence,
  transcriptionClassName,
  transcriptionContainerClassName,
  preload = "auto",
  playsInline = true,
  hidePlayPause,
  hideMuteUnmute,
  hideFullScreen,
  hideClose,
  hideNewTab,
  hideTranscription,
  hideLoader = false,
  ctaHoverColor,
  onNewTabClick,
  onCloseClick,
  onFullScreenClick,
  onVideoLoaded,
  onThumbnailLoad,
  onThumbnailLoadError,
  onProgress,
  onPlay,
  onPause,
  videoRef,
  containerRef,
  hideTimer,
  showProgressBar,
  fadeControlsOnPlay = false,
  playPausePlacement = "lower-left" /* LowerLeft */,
  rounded,
  forceFirstFrame = true,
  forceShowControls = false,
  forceShowThumbnail = false,
  loadOnIntersect = false,
  muted: initialMuted = false,
  imageComponent: DefaultImageComponent,
  closedCaptionClassName
}) {
  const [activeDefaultFullScreen, setActiveDefaultFullScreen] = (0, import_react38.useState)(false);
  const [playing, setPlaying] = (0, import_react38.useState)(false);
  const [muted, setMuted] = (0, import_react38.useState)(initialMuted);
  const [videoLoaded, setVideoLoaded] = (0, import_react38.useState)(false);
  const [thumbnailClicked, setThumbnailClicked] = (0, import_react38.useState)(false);
  const videoElement = videoRef != null ? videoRef : (0, import_react38.useRef)(null);
  const containerElement = containerRef != null ? containerRef : (0, import_react38.useRef)(null);
  const toggleMute = () => setMuted(!muted);
  const togglePlay = (0, import_react38.useCallback)(
    (play) => {
      if (!videoElement.current)
        return;
      if (play) {
        void videoElement.current.play();
        setThumbnailClicked(true);
      } else {
        videoElement.current.pause();
      }
      setPlaying(play);
    },
    [videoLoaded, videoElement.current]
  );
  const onVideoLoadedHandler = () => {
    setVideoLoaded(true);
    onVideoLoaded == null ? void 0 : onVideoLoaded();
  };
  const onCloseClickHandler = () => {
    togglePlay(false);
    onCloseClick == null ? void 0 : onCloseClick();
  };
  (0, import_react38.useEffect)(() => {
    if (videoElement.current && !videoLoaded && preload === "auto") {
      videoElement.current.load();
    }
  }, []);
  const onVolumeChangeHandler = (0, import_react38.useCallback)(() => {
    var _a;
    if (!videoLoaded || !videoElement.current)
      return;
    setMuted((_a = videoElement.current) == null ? void 0 : _a.muted);
  }, [videoElement.current]);
  const toggleFullScreen = (0, import_react38.useCallback)(() => {
    if (showDefaultFullScreen && (videoElement == null ? void 0 : videoElement.current)) {
      openFullScreen(videoElement == null ? void 0 : videoElement.current);
    } else {
      onFullScreenClick == null ? void 0 : onFullScreenClick();
    }
  }, [showDefaultFullScreen, fullScreen]);
  const onVideoContainerClickHandler = () => {
    if (document.fullscreenElement != null || document.webkitFullscreenElement != null || document.mozFullScreenElement != null) {
      console.log(
        "Video fullscreen is active. Will use default event handlers."
      );
      return;
    }
    togglePlay(!playing);
  };
  useVideoProgress({
    videoRef: videoElement,
    onProgress
  });
  (0, import_react38.useEffect)(() => {
    if (!videoElement.current)
      return;
    videoElement.current.onfullscreenchange = () => {
      setActiveDefaultFullScreen(document.fullscreenElement !== null);
    };
    videoElement.current.onwebkitfullscreenchange = () => {
      setActiveDefaultFullScreen(document.webkitFullscreenElement !== null);
    };
    videoElement.current.onmozfullscreenchange = () => {
      setActiveDefaultFullScreen(document.fullscreenElement !== null);
    };
  }, [activeDefaultFullScreen, videoElement.current, document]);
  (0, import_react38.useEffect)(() => {
    if (!loadOnIntersect || !(videoElement == null ? void 0 : videoElement.current) || !(containerElement == null ? void 0 : containerElement.current))
      return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          var _a, _b;
          if (entry.isIntersecting) {
            (_a = videoElement == null ? void 0 : videoElement.current) == null ? void 0 : _a.setAttribute("preload", "auto");
            (_b = videoElement == null ? void 0 : videoElement.current) == null ? void 0 : _b.load();
            if (videoElement == null ? void 0 : videoElement.current) {
              observer.unobserve(videoElement == null ? void 0 : videoElement.current);
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      }
    );
    observer.observe(videoElement == null ? void 0 : videoElement.current);
  }, [videoElement == null ? void 0 : videoElement.current, loadOnIntersect]);
  const activeCustomFullScreen = !activeDefaultFullScreen && fullScreen;
  const imageProps = {
    src: videoThumbnail,
    width: 0,
    height: 0,
    alt: "Video Thumbnail",
    onClick: () => setThumbnailClicked(true),
    className: (0, import_classnames25.default)(
      videoThumbnailClassName,
      "v2-w-auto v2-h-auto v2-absolute v2-object-cover v2-top-0 v2-cursor-pointer",
      {
        "!v2-z-20": !thumbnailClicked,
        "!v2-z-0 !v2-hidden": thumbnailClicked
      }
    ),
    onLoad: onThumbnailLoad,
    onError: onThumbnailLoadError
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react38.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return videoThumbnail;
      }
    })
  ) : /* @__PURE__ */ import_react38.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react38.default.createElement(
    "div",
    {
      className: (0, import_classnames25.default)(
        containerClassName,
        "v2-group/video-player v2-overflow-hidden",
        {
          "v2-cursor-pointer v2-inline-flex v2-relative": !fullScreen,
          "v2-fixed v2-transform v2-left-1/2 v2-top-1/2 -v2-translate-x-1/2 ": fullScreen,
          "-v2-translate-y-1/2 v2-translate v2-z-40 v2-w-screen sm:v2-w-auto sm:v2-h-auto v2-flex v2-justify-center": fullScreen,
          "v2-rounded-[10px]": rounded,
          "v2-z-0": !fullScreen
        }
      ),
      ref: containerElement
    },
    /* @__PURE__ */ import_react38.default.createElement(
      "div",
      {
        key: videoUrl,
        className: (0, import_classnames25.default)("v2-flex v2-relative v2-w-full v2-group", {
          "v2-drop-shadow v2-shadow": activeCustomFullScreen
        })
      },
      /* @__PURE__ */ import_react38.default.createElement("div", { className: "v2-w-full", onClick: onVideoContainerClickHandler }, !hideLoader && /* @__PURE__ */ import_react38.default.createElement(
        "span",
        {
          className: (0, import_classnames25.default)(
            "v2-absolute v2-w-full v2-h-full v2-flex v2-flex-col v2-bg-neutral-400",
            {
              "v2-animate-fade-out": videoLoaded
            }
          )
        }
      ), forceShowThumbnail && videoThumbnail && imageComponent, /* @__PURE__ */ import_react38.default.createElement(
        "video",
        {
          id: "bonjoro-video-player",
          ref: videoElement,
          className: (0, import_classnames25.default)("bonjoro-video-player v2-cursor-pointer", {
            "v2-object-cover": !activeDefaultFullScreen,
            "v2-h-full v2-w-full": activeCustomFullScreen,
            [videoClassName != null ? videoClassName : ""]: !fullScreen,
            "!v2-z-0": forceShowThumbnail && !thumbnailClicked,
            "!v2-z-10": forceShowThumbnail && thumbnailClicked
          }),
          style: videoStyle,
          poster: videoThumbnail,
          title: videoTitle,
          controls: showDefaultControls,
          playsInline,
          "webkit-playsinline": playsInline && "webkit-playsinline",
          preload,
          autoPlay,
          muted,
          loop,
          onTouchEnd: (event) => {
            event.preventDefault();
            togglePlay(!playing);
          },
          onTouchMove: (event) => {
            event.preventDefault();
          },
          onPlay: () => {
            togglePlay(true);
            onPlay == null ? void 0 : onPlay();
          },
          onPause: () => {
            togglePlay(false);
            onPause == null ? void 0 : onPause();
          },
          onLoadedData: onVideoLoadedHandler,
          onVolumeChange: onVolumeChangeHandler,
          src: forceFirstFrame ? `${videoUrl}#t=0.001` : videoUrl
        },
        children
      )),
      !showDefaultControls && /* @__PURE__ */ import_react38.default.createElement(
        VideoControls,
        {
          fullScreen,
          playing,
          muted,
          hideClose,
          hideNewTab,
          hidePlayPause,
          hideMuteUnmute,
          hideFullScreen,
          hideTimer,
          hideTranscription,
          onPlayPauseClick: () => togglePlay(!playing),
          onMuteUnmuteClick: toggleMute,
          onFullScreenClick: toggleFullScreen,
          onNewTabClick,
          onCloseClick: onCloseClickHandler,
          ctaHoverColor,
          leftHeaderComponent,
          footerComponent,
          transcription,
          initialTranscriptionState,
          transcriptMode,
          transcriptionTogglerPosition,
          transcriptionMaxWordsPerSentence,
          transcriptionClassName,
          transcriptionContainerClassName,
          showControls: forceShowControls || videoLoaded,
          videoRef: videoElement,
          showProgressBar: videoLoaded && showProgressBar,
          fadeControlsOnPlay,
          closedCaptionClassName,
          playPauseStyle,
          playPauseClassName,
          playPausePlacement
        }
      )
    )
  );
}

// src/components/EmbedTile/EmbedTileMediaTile.tsx
var playIcon = "https://cdn.bonjoro.com/assets/Flat-icons/play.svg";
var PlayIconContainer = import_styled6.default.span`
  ${({ bgColor }) => {
  if (bgColor) {
    return `background-color:  ${bgColor} !important`;
  }
}}
`;
function EmbedTileMediaTile(_a) {
  var _b = _a, {
    type,
    url,
    thumbnailUrl,
    transcriptionClassName,
    onThumbnailLoad,
    onThumbnailLoadError,
    theme: theme2,
    playable = false,
    hidePlayIcon = false,
    preload = "auto",
    loadOnIntersect = false,
    onClick,
    className,
    imageComponent: DefaultImageComponent
  } = _b, props = __objRest(_b, [
    "type",
    "url",
    "thumbnailUrl",
    "transcriptionClassName",
    "onThumbnailLoad",
    "onThumbnailLoadError",
    "theme",
    "playable",
    "hidePlayIcon",
    "preload",
    "loadOnIntersect",
    "onClick",
    "className",
    "imageComponent"
  ]);
  const defaultClassName = (0, import_classnames26.default)(className, genericTileHoverEffectClassName, [
    "v2-object-cover v2-h-auto v2-w-full v2-cursor-pointer v2-drop-shadow"
  ]);
  const imageProps = {
    src: thumbnailUrl != null ? thumbnailUrl : url,
    alt: "Media Tile",
    width: 0,
    height: 0,
    className: defaultClassName,
    onClick,
    onLoad: onThumbnailLoad,
    onError: onThumbnailLoadError
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react39.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return thumbnailUrl != null ? thumbnailUrl : url;
      }
    })
  ) : /* @__PURE__ */ import_react39.default.createElement("img", __spreadValues({}, imageProps));
  if (type === "video" /* Video */ && !playable) {
    return /* @__PURE__ */ import_react39.default.createElement("div", { className: "v2-relative v2-w-full v2-group" }, !hidePlayIcon && /* @__PURE__ */ import_react39.default.createElement(
      PlayIconContainer,
      {
        bgColor: theme2 == null ? void 0 : theme2.primaryColor,
        className: (0, import_classnames26.default)(genericTileHoverEffectClassName, [
          "v2-absolute v2-top-1/2 v2-left-1/2 v2-z-20 v2-flex v2-bg-neutral-900/50",
          "-v2-translate-x-1/2 -v2-translate-y-1/2 v2-rounded-full v2-p-3"
        ])
      },
      /* @__PURE__ */ import_react39.default.createElement(
        Image,
        {
          imageUrl: playIcon,
          className: "v2-h-[30px] v2-w-[30px] v2-relative"
        }
      )
    ), thumbnailUrl ? imageComponent : /* @__PURE__ */ import_react39.default.createElement(
      "video",
      {
        src: `${url}#t=1.00`,
        className: (0, import_classnames26.default)(defaultClassName, "v2-z-10"),
        muted: true,
        onClick
      }
    ));
  }
  if (type === "video" /* Video */ && playable) {
    return /* @__PURE__ */ import_react39.default.createElement(
      VideoPlayerComponent,
      __spreadProps(__spreadValues({}, props), {
        containerClassName: defaultClassName,
        videoThumbnail: thumbnailUrl,
        onPlay: onClick,
        onPause: onClick,
        videoUrl: url,
        hidePlayPause: hidePlayIcon,
        hideFullScreen: true,
        hideMuteUnmute: true,
        hideClose: true,
        hideNewTab: true,
        hideLoader: true,
        fadeControlsOnPlay: true,
        forceShowControls: true,
        forceShowThumbnail: true,
        preload,
        loadOnIntersect,
        onThumbnailLoad,
        onThumbnailLoadError,
        videoClassName: "embed-tile-video-player v2-max-w-full v2-h-auto v2-block v2-align-middle",
        videoThumbnailClassName: "v2-max-w-full !v2-w-full v2-h-auto v2-block v2-align-middle",
        transcriptionClassName: (0, import_classnames26.default)(transcriptionClassName, "v2-text-sm"),
        imageComponent: DefaultImageComponent,
        playPauseStyle: { color: theme2 == null ? void 0 : theme2.primaryColor }
      })
    );
  }
  return imageComponent;
}

// src/components/EmbedTile/EmbedTileMediaContent.tsx
function EmbedTileAnchor(_a) {
  var _b = _a, {
    className,
    children
  } = _b, otherProps = __objRest(_b, [
    "className",
    "children"
  ]);
  return /* @__PURE__ */ import_react40.default.createElement(
    "a",
    __spreadProps(__spreadValues({}, otherProps), {
      className: (0, import_classnames27.default)(
        className,
        "v2-py-[1px] v2-px-5 v2-transition-all v2-h-full v2-w-full"
      )
    }),
    children
  );
}
function EmbedTileMediaContent({
  media,
  url,
  theme: theme2,
  playable,
  imageComponent
}) {
  const anchorProps = {
    target: "_blank",
    rel: "noopener noreferrer",
    href: url
  };
  if (!media || media.length == 0)
    return /* @__PURE__ */ import_react40.default.createElement(import_react40.default.Fragment, null);
  const defaultTileProps = { theme: theme2, playable, imageComponent };
  const groupOne = media.slice(0, media.length / 2);
  const groupTwo = media.slice(media.length / 2, media.length);
  const hasOneMedia = (media == null ? void 0 : media.length) == 1;
  const hasTwoMedia = (media == null ? void 0 : media.length) == 2;
  const hasThreeMedia = (media == null ? void 0 : media.length) == 3;
  const hasFourOrMoreMedia = (media == null ? void 0 : media.length) >= 4;
  return /* @__PURE__ */ import_react40.default.createElement(
    EmbedTileAnchor,
    __spreadProps(__spreadValues({}, anchorProps), {
      className: (0, import_classnames27.default)("v2-flex v2-gap-0.5 v2-px-5 v2-h-auto v2-w-full", {
        "v2-flex-row": hasThreeMedia || hasTwoMedia,
        "v2-flex-col": hasFourOrMoreMedia
      })
    }),
    (groupOne == null ? void 0 : groupOne.length) > 0 && /* @__PURE__ */ import_react40.default.createElement(
      "div",
      {
        className: (0, import_classnames27.default)("v2-flex v2-h-full v2-gap-0.5", {
          "v2-flex-row": hasFourOrMoreMedia,
          "!v2-w-full": hasOneMedia || hasFourOrMoreMedia,
          "v2-w-1/2": !hasOneMedia
        })
      },
      groupOne.slice(0, 2).map((item, index) => /* @__PURE__ */ import_react40.default.createElement(
        EmbedTileMediaTile,
        __spreadProps(__spreadValues(__spreadValues({
          key: index
        }, defaultTileProps), item), {
          className: (0, import_classnames27.default)(item == null ? void 0 : item.className, {
            "!v2-h-[100px] v2-w-1/2": (groupOne == null ? void 0 : groupOne.length) >= 2,
            "v2-rounded-tl": (groupOne == null ? void 0 : groupOne.length) >= 2 && index == 0,
            "v2-rounded-tr": (groupOne == null ? void 0 : groupOne.length) >= 2 && index == 1,
            "v2-h-[202px] v2-rounded-l": (groupOne == null ? void 0 : groupOne.length) == 1
          })
        })
      ))
    ),
    (groupTwo == null ? void 0 : groupTwo.length) > 0 && /* @__PURE__ */ import_react40.default.createElement(
      "div",
      {
        className: (0, import_classnames27.default)("v2-flex v2-h-full v2-gap-0.5", {
          "v2-flex-row": hasFourOrMoreMedia,
          "v2-flex-col": !hasFourOrMoreMedia,
          "!v2-w-full": hasOneMedia || hasFourOrMoreMedia,
          "v2-w-1/2": !hasOneMedia
        })
      },
      groupTwo.slice(0, 2).map((item, index) => /* @__PURE__ */ import_react40.default.createElement(
        EmbedTileMediaTile,
        __spreadProps(__spreadValues(__spreadValues({
          key: index
        }, defaultTileProps), item), {
          className: (0, import_classnames27.default)(item == null ? void 0 : item.className, {
            "!v2-h-[100px]": (groupTwo == null ? void 0 : groupTwo.length) >= 2,
            "!v2-w-1/2": (groupTwo == null ? void 0 : groupTwo.length) >= 2 && hasFourOrMoreMedia,
            "!v2-w-full": (groupTwo == null ? void 0 : groupTwo.length) == 1,
            "v2-rounded-bl": hasFourOrMoreMedia && (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 0,
            "v2-rounded-tr": !hasFourOrMoreMedia && (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 0,
            "v2-rounded-br": (groupTwo == null ? void 0 : groupTwo.length) >= 2 && index == 1,
            "v2-h-[202px] v2-rounded-r": (groupOne == null ? void 0 : groupOne.length) >= 1 && (groupTwo == null ? void 0 : groupTwo.length) == 1,
            "v2-rounded": (groupOne == null ? void 0 : groupOne.length) == 0 && (groupTwo == null ? void 0 : groupTwo.length) == 1
          })
        })
      ))
    )
  );
}

// src/components/EmbedTile/EmbedTileLinkContent.tsx
var import_react41 = __toESM(require("react"));
var import_classnames28 = __toESM(require("classnames"));
function getProperLink(links) {
  const completeLinks = links.filter(
    (link) => link.url && link.imageUrl && link.title && link.description
  );
  if (completeLinks.length > 0)
    return completeLinks[0];
  return links[0];
}
function EmbedTileLinkContent({
  links,
  className,
  imageComponent: DefaultImageComponent
}) {
  if (!links || links && (links == null ? void 0 : links.length) === 0)
    return /* @__PURE__ */ import_react41.default.createElement(import_react41.default.Fragment, null);
  const { url, imageUrl, title, description } = getProperLink(links);
  const urlObject = new URL(url);
  const imageProps = {
    src: imageUrl,
    alt: "Link Content",
    width: 0,
    height: 0,
    className: "v2-w-full v2-h-[160px] v2-object-cover"
  };
  const imageComponent = DefaultImageComponent ? /* @__PURE__ */ import_react41.default.createElement(
    DefaultImageComponent,
    __spreadProps(__spreadValues({}, imageProps), {
      loader: () => {
        return imageUrl;
      }
    })
  ) : /* @__PURE__ */ import_react41.default.createElement("img", __spreadValues({}, imageProps));
  return /* @__PURE__ */ import_react41.default.createElement(
    "a",
    {
      className: (0, import_classnames28.default)(className, ["v2-py-[1px] v2-px-5 v2-flex v2-flex-col"]),
      target: "_blank",
      rel: "noopener noreferrer",
      href: url
    },
    /* @__PURE__ */ import_react41.default.createElement(
      "div",
      {
        className: (0, import_classnames28.default)(
          genericTileHoverEffectClassName,
          "v2-drop-shadow v2-w-full v2-h-full"
        )
      },
      imageUrl && imageComponent,
      /* @__PURE__ */ import_react41.default.createElement("div", { className: "v2-p-2.5 v2-bg-neutral-50 v2-flex v2-flex-col v2-gap-[5px]" }, /* @__PURE__ */ import_react41.default.createElement("span", { className: "v2-text-neutral-500 v2-text-xs v2-truncate" }, urlObject.host.toUpperCase()), title && /* @__PURE__ */ import_react41.default.createElement("span", { className: "v2-text-neutral-900 v2-font-bold v2-text-xs v2-truncate" }, title), description && /* @__PURE__ */ import_react41.default.createElement(
        "span",
        {
          className: (0, import_classnames28.default)("v2-text-xs v2-truncate", {
            "v2-text-neutral-900 v2-font-bold": !title,
            "v2-text-neutral-500": title
          })
        },
        description
      ))
    )
  );
}

// src/components/EmbedTile/EmbedTile.tsx
var import_react_loading_skeleton3 = __toESM(require("react-loading-skeleton"));

// src/components/EmbedTile/EmbedTileErrorContent.tsx
var import_react42 = __toESM(require("react"));
var import_classnames29 = __toESM(require("classnames"));
function EmbedTileErrorContent({
  iconUrl,
  text,
  iconClassName,
  textClassName
}) {
  return /* @__PURE__ */ import_react42.default.createElement("div", { className: "v2-bg-neutral-50 v2-h-[120px] v2-mx-5 v2-flex v2-flex-col v2-items-center v2-justify-center v2-space-y-1" }, iconUrl && /* @__PURE__ */ import_react42.default.createElement(
    Image,
    {
      imageUrl: iconUrl,
      className: (0, import_classnames29.default)("v2-w-12 v2-h-12 v2-bg-neutral-500", iconClassName),
      hideWhiteBackground: true
    }
  ), text && /* @__PURE__ */ import_react42.default.createElement("div", { className: (0, import_classnames29.default)("v2-text-neutral-500", textClassName) }, text));
}

// src/components/EmbedTile/EmbedTile.tsx
var EmbedTile = import_react43.default.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      type,
      profile,
      text,
      media,
      reactions,
      url,
      links,
      theme: theme2,
      datetime,
      className,
      hideIcon: defaultHideIcon = false,
      hideText = false,
      hideMedia = false,
      hideLink = false,
      hideDateTime = false,
      hideReaction = false,
      onLoad,
      onClick,
      queued = false,
      playable = false,
      content: customContent,
      cornerRadius = 6,
      hideShadow = false,
      showBorder = false,
      borderWidth,
      borderColor,
      fontFamily,
      imageComponent,
      style
    } = _b, otherProps = __objRest(_b, [
      "type",
      "profile",
      "text",
      "media",
      "reactions",
      "url",
      "links",
      "theme",
      "datetime",
      "className",
      "hideIcon",
      "hideText",
      "hideMedia",
      "hideLink",
      "hideDateTime",
      "hideReaction",
      "onLoad",
      "onClick",
      "queued",
      "playable",
      "content",
      "cornerRadius",
      "hideShadow",
      "showBorder",
      "borderWidth",
      "borderColor",
      "fontFamily",
      "imageComponent",
      "style"
    ]);
    var _a2;
    (0, import_react43.useEffect)(() => {
      onLoad == null ? void 0 : onLoad();
    }, []);
    const {
      formattedDateTime,
      profileTagClassName,
      reactionClassName,
      hideIconWithoutProfile
    } = (0, import_react43.useMemo)(() => {
      const defaultProps = {
        formattedDateTime: datetime == null ? void 0 : datetime.toFormat("dd/LL/y"),
        profileTagClassName: "v2-text-blue-400",
        reactionClassName: "group-hover:v2-opacity-50",
        hideIconWithoutProfile: false
      };
      if (isBonjoroResponseEmbed(type)) {
        return __spreadProps(__spreadValues({}, defaultProps), {
          profileTagClassName: "v2-text-neutral-500",
          hideIconWithoutProfile: true
        });
      }
      return defaultProps;
    }, [type]);
    const content = () => {
      return /* @__PURE__ */ import_react43.default.createElement(
        "div",
        {
          className: (0, import_classnames30.default)([
            "v2-min-h-[120px] v2-flex v2-flex-col v2-w-full h-full v2-overflow-y-auto",
            "v2-scrollbar-thin v2-scrollbar-thumb-neutral-300 v2-overflow-x-hidden",
            "v2-scrollbar-thumb-rounded-full v2-text-neutral-900 v2-text-base v2-gap-y-[15px] "
          ])
        },
        customContent,
        queued && /* @__PURE__ */ import_react43.default.createElement(
          EmbedTileErrorContent,
          {
            iconUrl: "https://cdn.bonjoro.com/assets/Flat-icons/pending.svg",
            text: "Queued"
          }
        ),
        !hideText && text && /* @__PURE__ */ import_react43.default.createElement(
          EmbedTileTextContent,
          {
            type,
            text,
            style: { fontFamily }
          }
        ),
        !hideMedia && media && /* @__PURE__ */ import_react43.default.createElement(
          EmbedTileMediaContent,
          {
            media,
            url,
            theme: theme2,
            playable,
            imageComponent
          }
        ),
        !hideLink && links && (!media || media.length == 0) && /* @__PURE__ */ import_react43.default.createElement(EmbedTileLinkContent, { links })
      );
    };
    const footer = () => {
      if (hideDateTime && hideReaction)
        return /* @__PURE__ */ import_react43.default.createElement(import_react43.default.Fragment, null);
      return /* @__PURE__ */ import_react43.default.createElement(
        "div",
        {
          className: (0, import_classnames30.default)([
            "v2-flex v2-flex-row v2-gap-x-[15px]",
            "v2-items-center v2-h-[15px] v2-px-5 v2-mt-[15px]"
          ])
        },
        !hideReaction && /* @__PURE__ */ import_react43.default.createElement(
          EmbedTileReactionPanel,
          {
            type,
            url,
            reactions,
            reactionClassName,
            loading: queued
          }
        ),
        queued && /* @__PURE__ */ import_react43.default.createElement(
          import_react_loading_skeleton3.default,
          {
            baseColor: colors.neutral[200],
            highlightColor: colors.neutral[100],
            height: "100%",
            containerClassName: "v2-h-4 v2-w-3/5 v2-flex"
          }
        ),
        !hideDateTime && !queued && /* @__PURE__ */ import_react43.default.createElement("span", { className: "v2-text-neutral-500 v2-text-xs" }, formattedDateTime)
      );
    };
    const hideIcon = defaultHideIcon || hideIconWithoutProfile && profile == void 0;
    return /* @__PURE__ */ import_react43.default.createElement(
      "div",
      __spreadProps(__spreadValues({
        ref
      }, otherProps), {
        className: (0, import_classnames30.default)(
          className,
          [
            "v2-w-full v2-h-fit v2-min-h-[245px] v2-relative v2-gap-y-[15px]",
            "v2-flex v2-flex-col v2-py-5 v2-bg-white v2-break-inside-avoid"
          ],
          {
            "v2-shadow": !hideShadow
          }
        ),
        style: __spreadValues(__spreadValues({
          borderRadius: `${cornerRadius}px`
        }, showBorder && {
          border: "solid",
          borderWidth: `${borderWidth != null ? borderWidth : 1}px`,
          borderColor: `${borderColor != null ? borderColor : colors.neutral[500]}`
        }), style),
        onClick
      }),
      (!hideIcon || profile != void 0) && /* @__PURE__ */ import_react43.default.createElement("div", { className: "v2-flex v2-flex-row v2-h-10 v2-px-5 v2-gap-x-2 v2-justify-between" }, profile && /* @__PURE__ */ import_react43.default.createElement(
        EmbedTileProfilePanel,
        __spreadProps(__spreadValues({}, profile), {
          url: (_a2 = profile == null ? void 0 : profile.url) != null ? _a2 : url,
          tagClassName: profileTagClassName,
          hideProfileImage: otherProps == null ? void 0 : otherProps.hideProfileImage,
          hideProfileName: otherProps == null ? void 0 : otherProps.hideProfileName,
          hideProfileTag: otherProps == null ? void 0 : otherProps.hideProfileTag,
          imageComponent,
          loading: queued
        })
      ), !hideIcon && /* @__PURE__ */ import_react43.default.createElement(
        EmbedTileIconImage,
        {
          type,
          className: "v2-h-5 v2-w-5",
          width: 20,
          height: 20,
          imageComponent,
          theme: theme2
        }
      )),
      /* @__PURE__ */ import_react43.default.createElement(
        "div",
        {
          className: (0, import_classnames30.default)([
            "v2-flex v2-flex-col v2-h-full v2-w-full",
            "v2-min-h-[150px] v2-justify-between"
          ])
        },
        content(),
        footer()
      )
    );
  }
);

// src/components/EmbedTile/util.tsx
var import_react44 = __toESM(require("react"));
var defaultTwitterUrl = "https://x.com";
var mapTwitterProps = ({
  url,
  content,
  datetime
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    type: "twitter" /* Twitter */,
    profile: {
      name: (_a = content == null ? void 0 : content.profile) == null ? void 0 : _a.name,
      url: ((_b = content == null ? void 0 : content.profile) == null ? void 0 : _b.tag) ? `${defaultTwitterUrl}/${(_c = content == null ? void 0 : content.profile) == null ? void 0 : _c.tag}` : url,
      imageUrl: (_d = content == null ? void 0 : content.profile) == null ? void 0 : _d.img_url,
      tag: (_e = content == null ? void 0 : content.profile) == null ? void 0 : _e.tag
    },
    url,
    text: content == null ? void 0 : content.text,
    media: (_f = content == null ? void 0 : content.media) == null ? void 0 : _f.map((item) => {
      return {
        type: item == null ? void 0 : item.type,
        url: item == null ? void 0 : item.url,
        thumbnailUrl: item == null ? void 0 : item.preview_url
      };
    }),
    reactions: content == null ? void 0 : content.reactions,
    links: (_g = content == null ? void 0 : content.links) == null ? void 0 : _g.map((item) => {
      return {
        url: item == null ? void 0 : item.url,
        imageUrl: item == null ? void 0 : item.img_url,
        title: item == null ? void 0 : item.title,
        description: item == null ? void 0 : item.description
      };
    }),
    queued: content === null,
    content: ((_h = content == null ? void 0 : content.error) == null ? void 0 : _h.title) ? /* @__PURE__ */ import_react44.default.createElement(
      EmbedTileErrorContent,
      {
        iconUrl: " https://cdn.bonjoro.com/assets/Flat-icons/error.svg",
        text: content.error.title
      }
    ) : void 0,
    datetime
  };
};

// src/components/EmbedTile/index.ts
var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["Photo"] = "photo";
  MediaType2["Video"] = "video";
  return MediaType2;
})(MediaType || {});
var EmbedTileType5 = /* @__PURE__ */ ((EmbedTileType6) => {
  EmbedTileType6["Twitter"] = "twitter";
  EmbedTileType6["LinkedIn"] = "linkedin";
  EmbedTileType6["BonjoroResponse"] = "bonjoro_response";
  return EmbedTileType6;
})(EmbedTileType5 || {});
var ReactionType2 = /* @__PURE__ */ ((ReactionType3) => {
  ReactionType3["Like"] = "like";
  ReactionType3["Celebrate"] = "celebrate";
  ReactionType3["Support"] = "support";
  ReactionType3["Love"] = "love";
  ReactionType3["Insightful"] = "insightful";
  ReactionType3["Funny"] = "funny";
  return ReactionType3;
})(ReactionType2 || {});
var embedTileDetails = {
  ["twitter" /* Twitter */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/twitter-x-black.svg",
      iconType: "image"
    },
    reactions: {
      ["like" /* Like */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/twitter-reaction-heart.svg",
        iconType: "masked_image",
        iconClassName: "v2-bg-magenta-300"
      }
    }
  },
  ["linkedin" /* LinkedIn */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/linkedin.svg",
      iconType: "image"
    },
    reactions: {
      ["like" /* Like */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-like.svg",
        iconType: "image"
      },
      ["celebrate" /* Celebrate */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-celebrate.svg",
        iconType: "image"
      },
      ["support" /* Support */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-support.svg",
        iconType: "image"
      },
      ["love" /* Love */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-love.svg",
        iconType: "image"
      },
      ["insightful" /* Insightful */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-insightful.svg",
        iconType: "image"
      },
      ["funny" /* Funny */]: {
        url: "https://cdn.bonjoro.com/assets/Flat-icons/socials/reactions/linkedin-reaction-funny.svg",
        iconType: "image"
      }
    }
  },
  ["bonjoro_response" /* BonjoroResponse */]: {
    icon: {
      url: "https://cdn.bonjoro.com/assets/Flat-icons/quote.svg",
      iconType: "masked_image",
      iconClassName: "v2-bg-neutral-500"
    }
  }
};
var genericTileHoverEffectClassName = "hover:v2-scale-[0.99] hover:v2-shadow group-hover:v2-scale-[0.99] group-hover:v2-shadow v2-transition-all v2-ease-in";
function isTwitterEmbed(type) {
  return type === "twitter" /* Twitter */;
}
function isLinkedinEmbed(type) {
  return type === "linkedin" /* LinkedIn */;
}
function isBonjoroResponseEmbed(type) {
  return type === "bonjoro_response" /* BonjoroResponse */;
}
